<template>
  <div>
    <div>
      <NavBar @update-studentID="studentID = $event" />
      <AlertBox ref="alertBox" />
    </div>
    <!-- UserPage content here -->
    <div class="container-fluid screen-control bg-white">
      <div class="loan-page-shell pt-2 pb-4">
        <!-- Progress bar -->
        <div class="px-0 progress-sticky-shell">
          <div class="con-header px-3 text-center progress-sticky">
            <div class="progress-container">
              <div class="progress-step active">
                <div class="step-circle">1</div>
                <div class="step-label active">ข้อมูลการศึกษา</div>
              </div>
              <div class="progress-line"></div>

              <div class="progress-step pgs-step-2">
                <div class="step-circle">2</div>
                <div class="step-label sl-step-2">ข้อมูลส่วนตัว</div>
              </div>
              <div class="progress-line"></div>

              <div class="progress-step pgs-step-3">
                <div class="step-circle">3</div>
                <div class="step-label sl-step-3">
                  ข้อมูลบิดา มารดา<br />หรือผู้ปกครอง
                </div>
              </div>
              <div class="progress-line"></div>

              <div class="progress-step pgs-step-4">
                <div class="step-circle">4</div>
                <div class="step-label sl-step-4">
                  ความจำเป็น<br />ในการขอกู้ยืมเงิน
                </div>
              </div>
              <div class="progress-line"></div>

              <div class="progress-step pgs-step-5">
                <div class="step-circle">5</div>
                <div class="step-label sl-step-5">
                  ยืนยันคำขอ<br />กู้ยืมเงิน
                </div>
              </div>
              <div class="progress-line"></div>

              <div class="progress-step pgs-step-6">
                <div class="step-circle">6</div>
                <div class="step-label sl-step-6">สำเร็จ</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ข้อมูลการกู้ -->
        <div class="m-2">
          <div
            v-if="isMockMode"
            class="d-flex justify-content-end px-3 pb-2 mock-tools"
          >
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="isMockFilling"
              @click="fillMockDataUntilStep5"
            >
              {{ isMockFilling ? "กำลังใส่ข้อมูล..." : "ใส่ข้อมูลทดสอบถึงหน้า 5" }}
            </button>
          </div>
          <div class="con-header p-3">
            <div id="LoanForm" class="carousel slide">
              <div class="carousel-inner mb-5 bg-body-secondary shadow">
                <!-- Step 1 -->
                <div class="carousel-item px-3 py-2 active" id="form_step_1">
                  <div class="col">
                    <h5 class="my-2">ปีการศึกษาที่ขอยื่นกู้</h5>
                    <hr
                      style="
                        border: none;
                        height: 2px;
                        background-color: black;
                        margin: 10px 0px;
                      "
                    />
                    <div class="row">
                      <div class="mb-3 col-12 col-md">
                        <label for="user_lvlStudy"
                          >ระดับการศึกษา<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <select
                          name="user_lvlStudy"
                          id="user_lvlStudy"
                          required
                          class="form-select"
                          @change="
                            getFaculty();
                            getStudyField();
                          "
                          v-model="user_lvlStudy"
                        >
                          <option selected disabled value="">กรุณาเลือก</option>
                          <option
                            v-for="level in educationLevelOptions"
                            :key="level"
                            :value="level"
                          >
                            {{ level }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-3 col-12 col-md">
                        <label for="user_yearStudy"
                          >ปีการศึกษา<span class="text-danger">*</span></label
                        >
                        <select
                          name="user_yearStudy"
                          id="user_yearStudy"
                          class="form-select"
                          disabled
                          required
                        >
                          <option disable value="">กรุณาเลือก</option>
                          <option selected>{{ studyYear }}</option>
                        </select>
                      </div>
                      <div class="mb-3 col-12 col-md">
                        <label for="user_semesterStudy"
                          >ภาคเรียน<span class="text-danger">*</span></label
                        >
                        <select
                          name="user_semesterStudy"
                          id="user_semesterStudy"
                          class="form-select"
                          disabled
                          required
                        >
                          <option disabled value="">กรุณาเลือก</option>
                          <option selected>{{ studySemester }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="row">
                      <div class="mb-3 col-md">
                        <label for="user_faculty"
                          >สำนักวิชา<span class="text-danger">*</span></label
                        >
                        <select
                          name="user_faculty"
                          id="user_faculty"
                          class="form-select"
                          @change="getStudyField($event.target.value)"
                          required
                        >
                          <option selected disabled value="">กรุณาเลือก</option>
                          <option value="สำนักวิชา">สำนักวิชา</option>
                        </select>
                      </div>
                      <div class="mb-3 col-md">
                        <label for="user_fieldStudy"
                          >สาขาวิชา<span class="text-danger">*</span></label
                        >
                        <select
                          name="user_fieldStudy"
                          id="user_fieldStudy"
                          class="form-select"
                          required
                        >
                          <option value="" selected>กรุณาเลือกสำนักวิชา</option>
                        </select>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="user_studentType"
                        >ประเภทของผู้กู้ยืม<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <select
                        name="user_studentType"
                        id="user_studentType"
                        class="form-select"
                        required
                        v-model="user_studentType"
                        @change="updateNeededHours"
                      >
                        <option disabled selected value="">กรุณาเลือก</option>
                        <option value="รายใหม่">
                          รายใหม่
                        </option>
                        <option value="รายเก่า">
                          รายเก่า
                        </option>
                        <option
                          value="ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร"
                        >
                          ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร
                        </option>
                      </select>
                      <div
                        v-if="
                          user_studentType ===
                          'ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร'
                        "
                        class="mt-2 d-grid gap-2"
                      >
                        <div>
                          <label for="user_transcript_file"
                            >ใบแสดงผลการศึกษาตลอดหลักสูตร (Transcript)<span
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <input
                            class="d-block w-50 form-control"
                            type="file"
                            @change="input_file_size_limit($event)"
                            name="user_transcript_file"
                            id="user_transcript_file"
                            accept=".pdf"
                            required
                            v-if="!user_transcript_file_useOld"
                          />
                          <div class="my-2" v-if="user_transcript_file">
                            <div class="d-flex align-items-center gap-2">
                              <span>ใช้ไฟล์เก่า:</span>
                              <a
                                :href="getFileUrl(user_transcript_file)"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="text-primary text-decoration-underline"
                              >
                                คลิกเพื่อดูไฟล์
                              </a>
                              <input
                                type="checkbox"
                                v-model="user_transcript_file_useOld"
                                class="form-check-input"
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <label for="user_studentCertificate_file"
                            >หนังสือรับรองการเป็นนักศึกษา<span
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <input
                            class="d-block w-50 form-control"
                            type="file"
                            @change="input_file_size_limit($event)"
                            name="user_studentCertificate_file"
                            id="user_studentCertificate_file"
                            accept=".pdf"
                            required
                            v-if="!user_studentCertificate_file_useOld"
                          />
                          <div class="my-2" v-if="user_studentCertificate_file">
                            <div class="d-flex align-items-center gap-2">
                              <span>ใช้ไฟล์เก่า:</span>
                              <a
                                :href="getFileUrl(user_studentCertificate_file)"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="text-primary text-decoration-underline"
                              >
                                คลิกเพื่อดูไฟล์
                              </a>
                              <input
                                type="checkbox"
                                v-model="user_studentCertificate_file_useOld"
                                class="form-check-input"
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <label for="user_courseCertificate_file"
                            >หนังสือรับรองรายวิชาที่ต้องลงทะเบียนเรียนจากสถานศึกษาประจำปีสุดท้าย<span
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <input
                            class="d-block w-50 form-control"
                            type="file"
                            @change="input_file_size_limit($event)"
                            name="user_courseCertificate_file"
                            id="user_courseCertificate_file"
                            accept=".pdf"
                            required
                            v-if="!user_courseCertificate_file_useOld"
                          />
                          <div class="my-2" v-if="user_courseCertificate_file">
                            <div class="d-flex align-items-center gap-2">
                              <span>ใช้ไฟล์เก่า:</span>
                              <a
                                :href="getFileUrl(user_courseCertificate_file)"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="text-primary text-decoration-underline"
                              >
                                คลิกเพื่อดูไฟล์
                              </a>
                              <input
                                type="checkbox"
                                v-model="user_courseCertificate_file_useOld"
                                class="form-check-input"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="user_loanType"
                        >ลักษณะของผู้กู้ยืม<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <select
                        name="user_loanType"
                        id="user_loanType"
                        class="form-select w-25"
                        style="min-width: 150px"
                        required
                      >
                        <option disabled selected value="">กรุณาเลือก</option>
                        <option value="ลักษณะที่ 1">ลักษณะที่ 1</option>
                        <option value="ลักษณะที่ 2">ลักษณะที่ 2</option>
                      </select>
                    </div>

                    <div class="mb-3">
                      <label for="user_studentStatus"
                        >สถานภาพการเป็นนักศึกษา<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <select
                        name="user_studentStatus"
                        id="user_studentStatus"
                        class="form-select w-25"
                        style="min-width: 150px"
                        v-model="user_studentStatus"
                        required
                      >
                        <option disabled selected value="">กรุณาเลือก</option>
                        <option value="ปกติ">ปกติ</option>
                        <option value="ลาพักการศึกษา">ลาพักการศึกษา</option>
                        <option value="นักศึกษาแลกเปลี่ยน">
                          นักศึกษาแลกเปลี่ยน
                        </option>
                      </select>
                      <div
                        v-if="user_studentStatus === 'ลาพักการศึกษา'"
                        class="mt-2"
                      >
                        <label for="user_studentStatus_reason" class="p-0"
                          >เหตุผลการลาพักการศึกษา<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          type="text"
                          id="user_studentStatus_reason"
                          class="form-control w-75"
                          placeholder="กรุณาระบุเหตุผลการลาพักการศึกษา"
                          :required="user_studentStatus === 'ลาพักการศึกษา'"
                        />
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="user_studentID"
                        >รหัสนักศึกษา<span class="text-danger">*</span></label
                      >
                      <input
                        id="user_studentID"
                        type="number"
                        class="form-control w-25"
                        style="min-width: 150px"
                        disabled
                        required
                        :value="studentID"
                      />
                    </div>

                    <div class="mb-3">
                      <label for="user_gpax"
                        >ผลการเรียนเฉลี่ยสะสม(GPAX)<span class="text-danger"
                          >*</span
                        ><br />
                        <small class="text-secondary"
                          >กรุณากรอกตัวเลขทศนิยม เช่น 3.00, 2.59</small
                        >
                      </label>

                      <input
                        id="user_gpax"
                        type="number"
                        @keydown="input_number_block_mathsymbol_gpax"
                        @input="
                          lenght_Validation($event, 4);
                          validateNoLeadingZeros($event);
                        "
                        class="form-control w-25"
                        style="min-width: 150px"
                        @wheel.prevent
                        required
                      />
                      <div class="mt-2">
                        <label for="user_gpax_file"
                          >Pdf ผลการเรียนเฉลี่ยสะสม (GPAX)<span
                            class="text-danger"
                            >*</span
                          >
                          <br />
                          <small class="text-secondary"
                            >ไฟล์ PDF ขนาดไม่เกิน 10MB</small
                          >
                        </label>
                        <input
                          class="d-block w-50 form-control"
                          type="file"
                          @change="input_file_size_limit($event)"
                          name="user_gpax_file"
                          id="user_gpax_file"
                          accept=".pdf"
                          required
                          v-if="!user_gpax_file_useOld"
                        />
                        <div class="my-2" v-if="user_gpax_file">
                          <div class="d-flex align-items-center gap-2">
                            <span>ใช้ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(user_gpax_file)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="user_gpax_file_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step 2 -->
                <div class="carousel-item px-3 py-2" id="form_step_2">
                  <h6 class="my-2">
                    ข้อมูลส่วนตัว<span class="text-danger">*</span>
                  </h6>
                  <hr
                    style="
                      border: none;
                      height: 2px;
                      background-color: black;
                      margin: 10px 0px;
                    "
                  />

                  <div class="my-3">
                    <p class="mb-1">
                      รูปนักศึกษา <span class="text-danger">*</span>
                    </p>

                    <input
                      v-if="!user_imageFile_useOld"
                      class="d-block w-50 form-control form-control"
                      type="file"
                      @change="handleImageUpload"
                      id="user_imageFile"
                      name="user_imageFile"
                      accept=".jpg,.jpeg,.png"
                      required
                    />

                    <div
                      v-if="previewUrl"
                      :style="{
                        width: '200px',
                        aspectRatio: '4 / 3',
                        backgroundImage: `url(${previewUrl})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        marginTop: '10px',
                      }"
                    ></div>

                    <div class="my-2" v-if="user_imageFile">
                      <div class="d-flex align-items-center gap-2">
                        <span>ใช้ไฟล์เก่า:</span>
                        <a
                          :href="getFileUrl(user_imageFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="text-primary text-decoration-underline"
                        >
                          คลิกเพื่อดูไฟล์
                        </a>
                        <input
                          type="checkbox"
                          v-model="user_imageFile_useOld"
                          class="form-check-input"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="mb-2">
                    <label for="user_username"
                      >ชื่อ<span class="text-danger">*</span></label
                    >
                    <input
                      id="user_username"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>

                  <div class="mb-2">
                    <label for="user_surname"
                      >นามสกุล<span class="text-danger">*</span></label
                    >
                    <input
                      id="user_surname"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>

                  <div class="mb-2">
                    <label for="user_old"
                      >อายุ<span class="text-danger">*</span></label
                    >
                    <input
                      id="user_old"
                      type="number"
                      @keydown="input_number_block_mathsymbol"
                      class="form-control"
                      required
                      @wheel.prevent
                    />
                  </div>

                  <div class="mb-2">
                    <label for="user_phoneNumber"
                      >เบอร์โทรศัพท์เคลื่อนที่<span class="text-danger"
                        >*</span
                      ></label
                    >
                    <input
                      id="user_phoneNumber"
                      type="number"
                      @keydown="input_number_block_mathsymbol"
                      @input="lenght_Validation($event, 10)"
                      class="form-control"
                      required
                      @wheel.prevent
                    />
                  </div>

                  <div class="mb-2">
                    <label for="user_citizenID"
                      >หมายเลขบัตรประชาชน<span class="text-danger"
                        >*</span
                      ></label
                    >
                    <input
                      id="user_citizenID"
                      type="number"
                      @keydown="input_number_block_mathsymbol"
                      @input="lenght_Validation($event, 13)"
                      class="form-control"
                      required
                      @wheel.prevent
                    />
                  </div>

                  <div
                    class="mb-2"
                    v-if="
                      ![
                        'ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร',
                        'รายเก่า',
                      ].includes(user_studentType)
                    "
                  >
                    <label for="user_citizenID_file"
                      >{{ ncbDocumentLabel("หนังสือยินยอมพร้อมสำเนาบัตรประชาชนผู้กู้") }}<span
                        class="text-danger"
                        >*</span
                      ></label
                    >
                    <input
                      class="d-block w-50 form-control"
                      type="file"
                      @change="input_file_size_limit($event)"
                      name="user_citizenID_file"
                      id="user_citizenID_file"
                      accept=".pdf"
                      required
                      v-if="!user_citizenID_file_useOld"
                    />
                    <div class="my-2" v-if="user_citizenID_file">
                      <div class="d-flex align-items-center gap-2">
                        <span>ใช้ไฟล์เก่า:</span>
                        <a
                          :href="getFileUrl(user_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="text-primary text-decoration-underline"
                        >
                          คลิกเพื่อดูไฟล์
                        </a>
                        <input
                          type="checkbox"
                          v-model="user_citizenID_file_useOld"
                          class="form-check-input"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="mb-4" v-if="user_studentType === 'รายใหม่'">
                    <p class="m-0">
                      จบการศึกษาระดับ<span class="text-danger">*</span>
                    </p>
                    <select
                      v-model="formData.user_graduateLvl"
                      name="user_graduateLvl"
                      id="user_graduateLvl"
                      class="form-select w-25"
                      style="min-width: 150px"
                      required
                    >
                      <option disabled value="">กรุณาเลือก</option>
                      <option
                        v-for="level in graduatedLevelOptions"
                        :key="level"
                        :value="level"
                      >
                        {{ level }}
                      </option>
                    </select>
                  </div>

                  <div
                    class="mb-4"
                    id="div_fee_checkbox"
                    @change="removeError($event)"
                  >
                    <p class="m-0">
                      ได้รับค่าใช้จ่ายในชีวิตประจำวัน (เลือกได้มากกว่า 1
                      ข้อ)<span class="text-danger">*</span>
                    </p>
                    <div>
                      <!-- ได้รับค่าใช้จ่ายในชีวิตประจำวัน -->
                      <div id="user_DailyExpenses"></div>

                      <!-- This is too custom to be import from backend -->
                      <div>
                        <input
                          type="checkbox"
                          name="dailyFee"
                          value="จากการประกอบอาชีพ"
                          id="จากการประกอบอาชีพ"
                          class="me-2 form-check-input"
                          v-model="finance_income_checkbox"
                          required
                        />
                        <label for="จากการประกอบอาชีพ">จากการประกอบอาชีพ</label>
                      </div>
                      <div v-if="finance_income_checkbox">
                        <div>
                          <div class="d-flex align-items-center mb-2">
                            <label for="user_job">อาชีพ</label>
                            <input
                              type="text"
                              id="user_job"
                              class="form-control ms-2"
                              :required="finance_income_checkbox"
                              style="width: 150px"
                              v-model="formData.user_job"
                            />
                            <span class="text-danger">*</span>
                          </div>
                          <div class="d-flex align-items-center">
                            <label for="user_job_income" class="me-2"
                              >รายได้</label
                            >
                            <input
                              type="text"
                              id="user_job_income"
                              class="form-control me-2"
                              :required="finance_income_checkbox"
                              @keydown="input_number_block_mathsymbol"
                              @wheel.prevent
                              style="width: 150px"
                              @input="formatIncome('user_job_income')"
                              v-model="displayIncome.user_job_income"
                            />
                            <label for="user_job_income" class="mb-0">
                              บาท/ปี<span class="text-danger">*</span>
                            </label>
                          </div>
                          <div class="my-2">
                            <label for="income_file"
                              >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือน") }}<span class="text-danger"
                                >*</span
                              >
                              <br />
                              <small class="text-secondary"
                                >ไฟล์ PDF ขนาดไม่เกิน 10MB</small
                              >
                            </label>
                            <input
                              class="d-block w-50 form-control"
                              type="file"
                              @change="input_file_size_limit($event)"
                              name="income_file"
                              id="income_file"
                              accept=".pdf"
                              required
                              v-if="!income_file_useOld"
                            />
                            <div class="my-2" v-if="income_file">
                              <div class="d-flex align-items-center gap-2">
                                <span>ไฟล์เก่า:</span>
                                <a
                                  :href="getFileUrl(income_file)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="text-primary text-decoration-underline"
                                >
                                  คลิกเพื่อดูไฟล์
                                </a>
                                <input
                                  type="checkbox"
                                  v-model="income_file_useOld"
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <input
                          type="checkbox"
                          name="dailyFee"
                          value="ทุนการศึกษา"
                          id="ทุนการศึกษา"
                          class="me-2 form-check-input"
                          v-model="scholarship_income_checkbox"
                          required
                        />
                        <label for="ทุนการศึกษา">ทุนการศึกษา</label>
                      </div>
                      <div v-if="scholarship_income_checkbox">
                        <div>
                          <div class="d-flex align-items-center mb-2">
                            <label for="user_scholarship_income"
                              >ได้รับทุนการศึกษาจาก</label
                            >
                            <input
                              type="text"
                              id="user_scholarship_income"
                              class="form-control ms-2"
                              :required="scholarship_income_checkbox"
                              style="width: 150px"
                              v-model="user_scholarship_income"
                            />
                            <span class="text-danger">*</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 📝 เมนูใหม่: บัตรสวัสดิการแห่งรัฐ -->
                  <div class="mb-4" v-if="user_studentType === 'รายใหม่'">
                    <p class="m-0">
                      ผู้กู้มีบัตรสวัสดิการแห่งรัฐ หรือไม่<span class="text-danger">*</span>
                    </p>
                    <div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="has_welfare_card"
                          id="welfare_yes"
                          value="มี"
                          v-model="formData.has_welfare_card"
                        />
                        <label class="form-check-label" for="welfare_yes">
                          มี
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="has_welfare_card"
                          id="welfare_no"
                          value="ไม่มี"
                          v-model="formData.has_welfare_card"
                        />
                        <label class="form-check-label" for="welfare_no">
                          ไม่มี
                        </label>
                      </div>
                      
                      <!-- แสดงช่องอัปโหลดไฟล์ถ้าเลือก "มี" -->
                      <div v-if="formData.has_welfare_card === 'มี'" class="mt-2">
                        <label for="welfare_card_file">
                          แนบสำเนาบัตรสวัสดิการแห่งรัฐ<span class="text-danger">*</span>
                          <br />
                          <small class="text-secondary">
                            ไฟล์ PDF ขนาดไม่เกิน 10MB
                          </small>
                        </label>
                        <input
                          class="d-block w-50 form-control"
                          type="file"
                          @change="(e) => { input_file_size_limit(e); if(e.target.files[0]) welfare_card_file = e.target.files[0]; }"
                          name="welfare_card_file"
                          id="welfare_card_file"
                          accept=".pdf"
                          :required="formData.has_welfare_card === 'มี'"
                          v-if="!welfare_card_file_useOld"
                        />
                        <div class="my-2" v-if="welfare_card_file">
                          <div class="d-flex align-items-center gap-2">
                            <span>ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(welfare_card_file)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="welfare_card_file_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 📝 เมนูใหม่: ทุน กสศ. -->
                  <div class="mb-4" v-if="user_studentType === 'รายใหม่'">
                    <p class="m-0">
                      ผู้กู้เคยรับทุนการศึกษา กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.) หรือไม่<span class="text-danger">*</span>
                    </p>
                    <div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="has_eef_scholarship"
                          id="eef_yes"
                          value="เคย"
                          v-model="formData.has_eef_scholarship"
                        />
                        <label class="form-check-label" for="eef_yes">
                          เคย
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="has_eef_scholarship"
                          id="eef_no"
                          value="ไม่เคย"
                          v-model="formData.has_eef_scholarship"
                        />
                        <label class="form-check-label" for="eef_no">
                          ไม่เคย
                        </label>
                      </div>
                      
                      <!-- แสดงช่องอัปโหลดไฟล์ถ้าเลือก "เคย" -->
                      <div v-if="formData.has_eef_scholarship === 'เคย'" class="mt-2">
                        <label for="eef_scholarship_file">
                          แนบหลักฐานการรับทุน กสศ.<span class="text-danger">*</span>
                          <br />
                          <small class="text-secondary">
                            ไฟล์ PDF ขนาดไม่เกิน 10MB
                          </small>
                        </label>
                        <input
                          class="d-block w-50 form-control"
                          type="file"
                          @change="(e) => { input_file_size_limit(e); if(e.target.files[0]) eef_scholarship_file = e.target.files[0]; }"
                          name="eef_scholarship_file"
                          id="eef_scholarship_file"
                          accept=".pdf"
                          :required="formData.has_eef_scholarship === 'เคย'"
                          v-if="!eef_scholarship_file_useOld"
                        />
                        <div class="my-2" v-if="eef_scholarship_file">
                          <div class="d-flex align-items-center gap-2">
                            <span>ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(eef_scholarship_file)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="eef_scholarship_file_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="mb-4"
                    id="div_feeused_checkbox"
                    @change="removeError($event)"
                  >
                    <p class="m-0">
                      มีความประสงค์จะขอกู้ยืมเพื่อใช้ในการศึกษา (เลือกได้มากกว่า
                      1 ข้อ)<span class="text-danger">*</span>
                    </p>

                    <div id="user_feeused"></div>
                  </div>

                  <div class="mb-3">
                    <h6 class="mb-2">กิจกรรมจิตสาธารณะ</h6>
                    <div class="mb-2">
                      <div>
                        <label for="Public_Service_Number_MFU333"
                          >กิจกรรมจากเว็บไซต์ MFU CHARACTER (MFU333)
                        </label>
                        <div class="d-flex">
                          <label
                            for="Public_Service_Number_MFU333"
                            class="my-auto"
                          >
                            จำนวน</label
                          >
                          <input
                            type="number"
                            @wheel.prevent
                            @keydown="input_number_block_mathsymbol"
                            id="Public_Service_Number_MFU333"
                            class="form-control w-25 mx-2"
                            style="min-width: 75px"
                            required
                            v-model="formData.Public_Service_Number_MFU333"
                          />
                          <label
                            for="Public_Service_Number_MFU333"
                            class="my-auto"
                            >ชั่วโมง<span class="text-danger">*</span></label
                          >
                        </div>
                      </div>
                      <div
                        class="mt-2"
                        v-if="formData.Public_Service_Number_MFU333 > 0"
                      >
                        <label for="Public_Service_MFU333_File"
                          >แนบไฟล์<span class="text-danger">*</span>
                          <br />
                          <small class="text-secondary"
                            >ไฟล์ PDF ขนาดไม่เกิน 10MB</small
                          >
                        </label>
                        <input
                          class="d-block w-50 form-control"
                          type="file"
                          @change="input_file_size_limit($event)"
                          name="Public_Service_MFU333_File"
                          id="Public_Service_MFU333_File"
                          accept=".pdf"
                          :required="formData.Public_Service_Number_MFU333 > 0"
                          v-if="!Public_Service_MFU333_File_useOld"
                        />
                        <div class="my-2" v-if="Public_Service_MFU333_File">
                          <div class="d-flex align-items-center gap-2">
                            <span>ใช้ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(Public_Service_MFU333_File)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="Public_Service_MFU333_File_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div>
                        <label for="Public_Service_Number_selfCreated"
                          >กิจกรรมสร้างเอง
                        </label>
                        <div class="d-flex">
                          <label
                            for="Public_Service_Number_selfCreated"
                            class="my-auto"
                          >
                            จำนวน</label
                          >
                          <input
                            type="number"
                            @wheel.prevent
                            @keydown="input_number_block_mathsymbol"
                            id="Public_Service_Number_selfCreated"
                            class="form-control w-25 mx-2"
                            style="min-width: 75px"
                            v-model="formData.Public_Service_Number_selfCreated"
                            required
                          />
                          <label
                            for="Public_Service_Number_selfCreated"
                            class="my-auto"
                            >ชั่วโมง<span class="text-danger">*</span></label
                          >
                        </div>
                      </div>
                      <div class="mt-2" v-if="formData.Public_Service_Number_selfCreated > 0">
                        <label for="Public_Service_selfCreated_File"
                          >แนบไฟล์<span class="text-danger">*</span>
                          <br />
                          <small class="text-secondary"
                            >ไฟล์ PDF ขนาดไม่เกิน 10MB</small
                          >
                        </label>
                        <input
                          class="d-block w-50 form-control"
                          type="file"
                          @change="input_file_size_limit($event)"
                          name="Public_Service_selfCreated_File"
                          id="Public_Service_selfCreated_File"
                          accept=".pdf"
                          :required="formData.Public_Service_Number_selfCreated > 0"
                          v-if="!Public_Service_selfCreated_File_useOld"
                        />
                        <div
                          class="my-2"
                          v-if="Public_Service_selfCreated_File"
                        >
                          <div class="d-flex align-items-center gap-2">
                            <span>ใช้ไฟล์เก่า:</span>
                            <a
                              :href="
                                getFileUrl(Public_Service_selfCreated_File)
                              "
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="Public_Service_selfCreated_File_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div>
                        <label for="Public_Service_Number_eLearning"
                          >เรียน set e-learning, หลักสูตรอื่นๆ ที่กองทุนกำหนด
                        </label>
                        <div class="d-flex">
                          <label
                            for="Public_Service_Number_eLearning"
                            class="my-auto"
                          >
                            จำนวน</label
                          >
                          <input
                            type="number"
                            @wheel.prevent
                            @keydown="input_number_block_mathsymbol"
                            id="Public_Service_Number_eLearning"
                            class="form-control w-25 mx-2"
                            style="min-width: 75px"
                            v-model="formData.Public_Service_Number_eLearning"
                            required
                          />
                          <label
                            for="Public_Service_eLearning_File"
                            class="my-auto"
                            >ชั่วโมง<span class="text-danger">*</span></label
                          >
                        </div>
                      </div>
                      <div class="mt-2" v-if="formData.Public_Service_Number_eLearning > 0">
                        <label for="Public_Service_eLearning_File"
                          >แนบไฟล์<span class="text-danger">*</span>
                          <br />
                          <small class="text-secondary"
                            >ไฟล์ PDF ขนาดไม่เกิน 10MB</small
                          >
                        </label>
                        <input
                          class="d-block w-50 form-control"
                          type="file"
                          @change="input_file_size_limit($event)"
                          name="Public_Service_eLearning_File"
                          id="Public_Service_eLearning_File"
                          accept=".pdf"
                          :required="formData.Public_Service_Number_eLearning > 0"
                          v-if="!Public_Service_eLearning_File_useOld"
                        />
                        <div class="my-2" v-if="Public_Service_eLearning_File">
                          <div class="d-flex align-items-center gap-2">
                            <span>ใช้ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(Public_Service_eLearning_File)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="Public_Service_eLearning_File_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 :style="{ color: isPassed ? 'green' : 'red' }">
                      รวม {{ totalPublicServiceNumber }} ชั่วโมง
                      (ต้องการอย่างน้อย {{ PublicServiceNumber_Needed }})
                    </h5>
                  </div>

                  <!-- User's fan info -->
                  <div class="bg-white mb-2 border border-2 rounded-1">
                    <div>
                      <div class="p-2">
                        <p>
                          สถานะภาพของผู้กู้ยืม<span class="text-danger">*</span>
                        </p>

                        <select
                          name="fan_status"
                          id="fan_status"
                          class="form-select w-25 mb-4"
                          required
                          @change="checkFanStatus"
                        >
                          <option selected disabled value="">กรุณาเลือก</option>
                          <option value="โสด">โสด</option>
                          <option value="มีคู่สมรส">มีคู่สมรส</option>
                        </select>

                        <div id="fan_info_from" v-if="showInput_fan">
                          <div class="row">
                            <div class="mb-3 col">
                              <label for="fan_citizenShip" class="mb-2"
                                >สัญชาติ<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <select
                                name="fan_citizenShip"
                                id="fan_citizenShip"
                                class="form-select w-50 mb-4"
                                v-model="fan_citizenShip"
                                required
                              >
                                <option selected value="ไทย">ไทย</option>
                                <option value="ต่างชาติ">ต่างชาติ</option>
                              </select>
                            </div>
                            <div class="mb-3 col-12 col-md"></div>
                          </div>

                          <div class="row">
                            <div
                              class="mb-3 col-12"
                              v-if="fan_citizenShip === 'ไทย'"
                            >
                              <label for="fan_citizenID"
                                >เลขบัตรประชาชน<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="fan_citizenID"
                                type="number"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                @input="lenght_Validation($event, 13)"
                                class="form-control mt-2"
                                :required="showInput_fan"
                              />
                              <div
                                class="mb-2"
                                v-if="
                                  ![
                                    'ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร',
                                    'รายเก่า',
                                  ].includes(user_studentType)
                                "
                              >
                                <label for="fan_citizenID_file"
                                  >หนังสือยินยอมพร้อมสำเนาบัตรประชาชน<span
                                    class="text-danger"
                                    >*</span
                                  ></label
                                >
                                <input
                                  class="d-block w-50 form-control"
                                  type="file"
                                  @change="input_file_size_limit($event)"
                                  name="fan_citizenID_file"
                                  id="fan_citizenID_file"
                                  accept=".pdf"
                                  required
                                  v-if="!fan_citizenID_file_useOld"
                                />
                                <div class="my-2" v-if="fan_citizenID_file">
                                  <div class="d-flex align-items-center gap-2">
                                    <span>ใช้ไฟล์เก่า:</span>
                                    <a
                                      :href="getFileUrl(fan_citizenID_file)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary text-decoration-underline"
                                    >
                                      คลิกเพื่อดูไฟล์
                                    </a>
                                    <input
                                      type="checkbox"
                                      v-model="fan_citizenID_file_useOld"
                                      class="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="mb-3 col-12"
                              v-if="fan_citizenShip === 'ต่างชาติ'"
                            >
                              <label for="fan_citizenID"
                                >เลขพาสปอร์ต<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="fan_citizenID"
                                type="text"
                                @wheel.prevent
                                class="form-control mt-2"
                                :required="showInput_fan"
                              />
                              <div class="mb-2">
                                <label for="fan_citizenID_file"
                                  >เอกสารสำเนาเลขพาสปอร์ต<span
                                    class="text-danger"
                                    >*</span
                                  ></label
                                >
                                <input
                                  class="d-block w-50 form-control"
                                  type="file"
                                  @change="input_file_size_limit($event)"
                                  name="fan_citizenID_file"
                                  id="fan_citizenID_file"
                                  accept=".pdf"
                                  required
                                  v-if="!fan_citizenID_file_useOld"
                                />
                                <div class="my-2" v-if="fan_citizenID_file">
                                  <div class="d-flex align-items-center gap-2">
                                    <span>ใช้ไฟล์เก่า:</span>
                                    <a
                                      :href="getFileUrl(fan_citizenID_file)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary text-decoration-underline"
                                    >
                                      คลิกเพื่อดูไฟล์
                                    </a>
                                    <input
                                      type="checkbox"
                                      v-model="fan_citizenID_file_useOld"
                                      class="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="mb-3 col-12 col-md">
                              <label for="fan_old"
                                >อายุ<span class="text-danger">*</span></label
                              >
                              <input
                                id="fan_old"
                                type="number"
                                class="form-control mt-2"
                                @keydown="input_number_block_mathsymbol"
                                :required="showInput_fan"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="fan_name"
                                >ชื่อ<span class="text-danger">*</span></label
                              >
                              <input
                                id="fan_name"
                                type="text"
                                class="form-control mt-2"
                                :required="showInput_fan"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="fan_surname"
                                >นามสกุล<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="fan_surname"
                                type="text"
                                class="form-control mt-2"
                                :required="showInput_fan"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="fan_phoneNumber"
                                >เบอร์โทรศัพท์เคลื่อนที่<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="fan_phoneNumber"
                                type="number"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                @input="lenght_Validation($event, 10)"
                                class="form-control mt-2"
                                :required="showInput_fan"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="fan_email">อีเมล</label>
                              <input
                                id="fan_email"
                                type="email"
                                class="form-control mt-2"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="fan_job"
                                >ปัจจุบันประกอบอาชีพ<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="fan_job"
                                type="text"
                                class="form-control mt-2"
                                :required="showInput_fan"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="fan_income"
                                >มีรายได้บาท/ปี (ไม่หักค่าใช้จ่าย)<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="fan_income"
                                type="text"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                class="form-control mt-2"
                                :required="showInput_fan"
                                @input="formatIncome('fan_income')"
                                v-model="displayIncome.fan_income"
                              />
                            </div>

                            <div class="mb-3">
                              <label for="fan_income_file"
                                >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนคู่สมรส/บัตรสวัสดิการแห่งรัฐ") }}
                                <br />
                                <small class="text-secondary"
                                  >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                    class="text-danger"
                                    >*</span
                                  ></small
                                >
                              </label>
                              <input
                                id="fan_income_file"
                                type="file"
                                @change="input_file_size_limit($event)"
                                class="form-control mt-2 w-50"
                                accept=".pdf"
                                required
                                v-if="!fan_income_file_useOld"
                              />
                              <div class="my-2" v-if="fan_income_file">
                                <div class="d-flex align-items-center gap-2">
                                  <span>ใช้ไฟล์เก่า:</span>
                                  <a
                                    :href="getFileUrl(fan_income_file)"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-primary text-decoration-underline"
                                  >
                                    คลิกเพื่อดูไฟล์
                                  </a>
                                  <input
                                    type="checkbox"
                                    v-model="fan_income_file_useOld"
                                    class="form-check-input"
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="mb-3">
                              <label for="fan_file"
                                >เอกสาร ใบสมรส
                                <br />
                                <small class="text-secondary"
                                  >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                    class="text-danger"
                                    >*</span
                                  ></small
                                >
                              </label>
                              <input
                                id="fan_file"
                                type="file"
                                @change="input_file_size_limit($event)"
                                class="form-control mt-2 w-50"
                                accept=".pdf"
                                required
                                v-if="!fanFile_useOld"
                              />
                              <div class="my-2" v-if="fanFile">
                                <div class="d-flex align-items-center gap-2">
                                  <span>ใช้ไฟล์เก่า:</span>
                                  <a
                                    :href="getFileUrl(fanFile)"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-primary text-decoration-underline"
                                  >
                                    คลิกเพื่อดูไฟล์
                                  </a>
                                  <input
                                    type="checkbox"
                                    v-model="fanFile_useOld"
                                    class="form-check-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="bg-white mb-2 border border-2 rounded-1"></div>
                    <div id="form_step_3_siblings">
                      <div class="p-2">
                        <div class="col">
                          <div class="mb-3">
                            <label for="siblings_count"
                              >จำนวนพี่น้อง (ไม่รวมผู้กู้ยืม)<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="siblings_count"
                              type="number"
                              min="0"
                              max="10"
                              class="form-control w-25"
                              style="min-width: 150px"
                              @input="handleSiblingsCountChange"
                              required
                            />
                            <small class="text-secondary"
                              >กรุณากรอกจำนวนพี่น้อง (ไม่รวมผู้กู้ยืม)</small
                            >
                          </div>

                          <div
                            v-if="siblingsCount > 0"
                            class="siblings-container"
                          >
                            <div
                              v-for="(sibling, index) in siblings"
                              :key="index"
                              class="sibling-form mb-4 p-3 border rounded"
                            >
                              <h6 class="mb-3">
                                ข้อมูลพี่น้องคนที่ {{ index + 1 }}
                              </h6>

                              <div class="row">
                                <div class="mb-3 col-12 col-md">
                                  <label :for="`sibling_status_${index}`"
                                    >สถานะ<span class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <select
                                    :id="`sibling_status_${index}`"
                                    class="form-select"
                                    v-model="sibling.status"
                                    @change="handleSiblingStatusChange(index)"
                                    required
                                  >
                                    <option value="" disabled>
                                      กรุณาเลือก
                                    </option>
                                    <option value="working">ทำงานแล้ว</option>
                                    <option value="studying">กำลังศึกษา</option>
                                  </select>
                                </div>
                              </div>

                              <div
                                v-if="sibling.status === 'working'"
                                class="working-fields"
                              >
                                <div class="row">
                                  <div class="mb-3 col-12 col-md">
                                    <label :for="`sibling_job_${index}`"
                                      >อาชีพ<span class="text-danger"
                                        >*</span
                                      ></label
                                    >
                                    <input
                                      :id="`sibling_job_${index}`"
                                      type="text"
                                      class="form-control"
                                      v-model="sibling.job"
                                      required
                                    />
                                  </div>
                                  <div class="mb-3 col-12 col-md">
                                    <label :for="`sibling_income_${index}`"
                                      >รายได้ต่อปี (บาท)<span
                                        class="text-danger"
                                        >*</span
                                      ></label
                                    >
                                    <input
                                      :id="`sibling_income_${index}`"
                                      type="number"
                                      min="0"
                                      class="form-control"
                                      v-model="sibling.income"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                v-if="sibling.status === 'studying'"
                                class="studying-fields"
                              >
                                <div class="row">
                                  <div class="mb-3 col-12 col-md">
                                    <label
                                      :for="`sibling_education_level_${index}`"
                                      >ระดับการศึกษา<span class="text-danger"
                                        >*</span
                                      ></label
                                    >
                                    <select
                                      :id="`sibling_education_level_${index}`"
                                      class="form-select"
                                      v-model="sibling.educationLevel"
                                      required
                                    >
                                      <option value="" disabled>
                                        กรุณาเลือก
                                      </option>
                                      <option value="ประถมศึกษา">
                                        ประถมศึกษา
                                      </option>
                                      <option value="มัธยมศึกษาตอนต้น">
                                        มัธยมศึกษาตอนต้น
                                      </option>
                                      <option value="มัธยมศึกษาตอนปลาย">
                                        มัธยมศึกษาตอนปลาย
                                      </option>
                                      <option
                                        value="ประกาศนียบัตรวิชาชีพ (ปวช.)"
                                      >
                                        ประกาศนียบัตรวิชาชีพ (ปวช.)
                                      </option>
                                      <option
                                        value="ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)"
                                      >
                                        ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)
                                      </option>
                                      <option value="ปริญญาตรี">
                                        ปริญญาตรี
                                      </option>
                                      <option value="ปริญญาโท">ปริญญาโท</option>
                                      <option value="ปริญญาเอก">
                                        ปริญญาเอก
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step 3 -->
                <div class="carousel-item p-3 text-black" id="form_step_3">
                  <!-- DAD -->
                  <div class="bg-white mb-2 border border-2 rounded-1">
                    <h5 class="my-2 p-2">บิดา</h5>
                    <hr
                      style="border: none; height: 2px; background-color: black"
                    />
                    <div>
                      <div class="p-2">
                        <p>สถานะ<span class="text-danger">*</span></p>

                        <select
                          name="dad_status"
                          id="dad_status"
                          class="form-select w-25 mb-4"
                          required
                          v-model="dad_status"
                        >
                          <option selected disabled value="">กรุณาเลือก</option>
                          <option value="มีชีวิตอยู่">มีชีวิตอยู่</option>
                          <option value="เสียชีวิต">เสียชีวิต</option>
                          <option value="ไม่ทราบข้อมูล">ไม่ทราบข้อมูล</option>
                        </select>

                        <div class="p-2" v-if="dad_status === 'เสียชีวิต'">
                          <div class="row">
                            <div class="mb-3 col">
                              <label for="dad_name"
                                >ชื่อ<span class="text-danger">*</span></label
                              >
                              <input
                                id="dad_name"
                                type="text"
                                class="form-control mt-2"
                                :required="dad_status === 'เสียชีวิต'"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="dad_surname"
                                >นามสกุล<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_surname"
                                type="text"
                                class="form-control mt-2"
                                :required="dad_status === 'เสียชีวิต'"
                              />
                            </div>
                          </div>

                          <div class="d-grid">
                            <label for="dad_death_certificate_file"
                              >แนบใบมรณะบัตร
                              <br />
                              <small class="text-secondary"
                                >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                  class="text-danger"
                                  >*</span
                                ></small
                              ></label
                            >
                            <input
                              type="file"
                              class="form-control"
                              @change="input_file_size_limit($event)"
                              id="dad_death_certificate_file"
                              accept=".pdf"
                              :required="dad_status === 'เสียชีวิต'"
                              v-if="!dad_death_certificate_file_useOld"
                            />
                            <div class="my-2" v-if="dad_death_certificate_file">
                              <div class="d-flex align-items-center gap-2">
                                <span>ใช้ไฟล์เก่า:</span>
                                <a
                                  :href="getFileUrl(dad_death_certificate_file)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="text-primary text-decoration-underline"
                                >
                                  คลิกเพื่อดูไฟล์
                                </a>
                                <input
                                  type="checkbox"
                                  v-model="dad_death_certificate_file_useOld"
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- แนบหนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ -->
                        <div class="p-2" v-if="dad_status === 'ไม่ทราบข้อมูล'">
                          <div class="d-grid">
                            <label for="dad_family_status_certificate_file"
                              >แนบหนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ
                              <br />
                              <small class="text-secondary"
                                >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                  class="text-danger"
                                  >*</span
                                ></small
                              ></label
                            >
                            <input
                              type="file"
                              class="form-control"
                              @change="input_file_size_limit($event)"
                              id="dad_family_status_certificate_file"
                              accept=".pdf"
                              :required="dad_status === 'ไม่ทราบข้อมูล'"
                              v-if="!dad_family_status_certificate_file_useOld"
                            />
                            <div
                              class="my-2"
                              v-if="dad_family_status_certificate_file"
                            >
                              <div class="d-flex align-items-center gap-2">
                                <span>ใช้ไฟล์เก่า:</span>
                                <a
                                  :href="
                                    getFileUrl(
                                      dad_family_status_certificate_file
                                    )
                                  "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="text-primary text-decoration-underline"
                                >
                                  คลิกเพื่อดูไฟล์
                                </a>
                                <input
                                  type="checkbox"
                                  v-model="
                                    dad_family_status_certificate_file_useOld
                                  "
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          id="dad_info_from"
                          v-if="dad_status === 'มีชีวิตอยู่'"
                        >
                          <div class="row">
                            <div class="mb-3 col">
                              <label for="dad_citizenShip" class="mb-2"
                                >สัญชาติ<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <select
                                name="dad_citizenShip"
                                id="dad_citizenShip"
                                class="form-select w-50 mb-4"
                                v-model="dad_citizenShip"
                                required
                              >
                                <option selected value="ไทย">ไทย</option>
                                <option value="ต่างชาติ">ต่างชาติ</option>
                              </select>
                            </div>
                            <div class="mb-3 col-12 col-md"></div>
                          </div>

                          <div class="row">
                            <div
                              class="mb-3 col-12"
                              v-if="dad_citizenShip === 'ไทย'"
                            >
                              <label for="dad_citizenID"
                                >เลขบัตรประชาชน<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_citizenID"
                                type="number"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                @input="lenght_Validation($event, 13)"
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                              <div
                                class="mb-2"
                                v-if="
                                  ![
                                    'ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร',
                                    'รายเก่า',
                                  ].includes(user_studentType)
                                "
                              >
                                <label for="dad_citizenID_file"
                                  >หนังสือยินยอมพร้อมสำเนาบัตรประชาชน<span
                                    class="text-danger"
                                    >*</span
                                  ></label
                                >
                                <input
                                  class="d-block w-50 form-control"
                                  type="file"
                                  @change="input_file_size_limit($event)"
                                  name="dad_citizenID_file"
                                  id="dad_citizenID_file"
                                  accept=".pdf"
                                  required
                                  v-if="!dad_citizenID_file_useOld"
                                />
                                <div class="my-2" v-if="dad_citizenID_file">
                                  <div class="d-flex align-items-center gap-2">
                                    <span>ใช้ไฟล์เก่า:</span>
                                    <a
                                      :href="getFileUrl(dad_citizenID_file)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary text-decoration-underline"
                                    >
                                      คลิกเพื่อดูไฟล์
                                    </a>
                                    <input
                                      type="checkbox"
                                      v-model="dad_citizenID_file_useOld"
                                      class="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="mb-3 col-12"
                              v-if="dad_citizenShip === 'ต่างชาติ'"
                            >
                              <label for="dad_citizenID"
                                >เลขพาสปอร์ต<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_citizenID"
                                type="text"
                                @wheel.prevent
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                              <div class="mb-2">
                                <label for="dad_citizenID_file"
                                  >เอกสารสำเนาเลขพาสปอร์ต<span
                                    class="text-danger"
                                    >*</span
                                  ></label
                                >
                                <input
                                  class="d-block w-50 form-control"
                                  type="file"
                                  @change="input_file_size_limit($event)"
                                  name="dad_citizenID_file"
                                  id="dad_citizenID_file"
                                  accept=".pdf"
                                  required
                                  v-if="!dad_citizenID_file_useOld"
                                />
                                <div class="my-2" v-if="dad_citizenID_file">
                                  <div class="d-flex align-items-center gap-2">
                                    <span>ใช้ไฟล์เก่า:</span>
                                    <a
                                      :href="getFileUrl(dad_citizenID_file)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary text-decoration-underline"
                                    >
                                      คลิกเพื่อดูไฟล์
                                    </a>
                                    <input
                                      type="checkbox"
                                      v-model="dad_citizenID_file_useOld"
                                      class="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="dad_old"
                                >อายุ<span class="text-danger">*</span></label
                              >
                              <input
                                id="dad_old"
                                type="number"
                                class="form-control mt-2"
                                @keydown="input_number_block_mathsymbol"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="dad_name"
                                >ชื่อ<span class="text-danger">*</span></label
                              >
                              <input
                                id="dad_name"
                                type="text"
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="dad_surname"
                                >นามสกุล<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_surname"
                                type="text"
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="dad_phoneNumber"
                                >เบอร์โทรศัพท์เคลื่อนที่<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_phoneNumber"
                                type="number"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                @input="lenght_Validation($event, 10)"
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="dad_email">อีเมล</label>
                              <input
                                id="dad_email"
                                type="email"
                                class="form-control mt-2"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="dad_job"
                                >ปัจจุบันประกอบอาชีพ<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_job"
                                type="text"
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="dad_income"
                                >มีรายได้บาท/ปี (ไม่หักค่าใช้จ่าย)<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="dad_income"
                                type="text"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                class="form-control mt-2"
                                :required="dad_status === 'มีชีวิตอยู่'"
                                @input="formatIncome('dad_income')"
                                v-model="displayIncome.dad_income"
                              />
                            </div>

                            <div class="mb-3">
                              <label for="dad_file"
                                >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนบิดา/บัตรสวัสดิการแห่งรัฐ") }}
                                <br />
                                <small class="text-secondary"
                                  >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                    class="text-danger"
                                    >*</span
                                  ></small
                                >
                              </label>
                              <input
                                id="dad_file"
                                type="file"
                                @change="input_file_size_limit($event)"
                                class="form-control mt-2 w-50"
                                accept=".pdf"
                                required
                                v-if="!dadFile_useOld"
                              />
                              <div class="my-2" v-if="dadFile">
                                <div class="d-flex align-items-center gap-2">
                                  <span>ใช้ไฟล์เก่า:</span>
                                  <a
                                    :href="getFileUrl(dadFile)"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-primary text-decoration-underline"
                                  >
                                    คลิกเพื่อดูไฟล์
                                  </a>
                                  <input
                                    type="checkbox"
                                    v-model="dadFile_useOld"
                                    class="form-check-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- MOM -->
                  <div class="bg-white mb-2 border border-2 rounded-1">
                    <h5 class="my-2 p-2">มารดา</h5>
                    <hr
                      style="border: none; height: 2px; background-color: black"
                    />
                    <div class="p-2">
                      <div>
                        <p>สถานะ<span class="text-danger">*</span></p>
                        <select
                          name="mom_status"
                          id="mom_status"
                          class="form-select w-25 mb-4"
                          required
                          v-model="mom_status"
                        >
                          <option selected disabled value="">กรุณาเลือก</option>
                          <option value="มีชีวิตอยู่">มีชีวิตอยู่</option>
                          <option value="เสียชีวิต">เสียชีวิต</option>
                          <option value="ไม่ทราบข้อมูล">ไม่ทราบข้อมูล</option>
                        </select>
                      </div>

                      <div class="p-2" v-if="mom_status === 'เสียชีวิต'">
                        <div class="row">
                          <div class="mb-3 col">
                            <label for="mom_name"
                              >ชื่อ<span class="text-danger">*</span></label
                            >
                            <input
                              id="mom_name"
                              type="text"
                              class="form-control mt-2"
                              :required="mom_status === 'เสียชีวิต'"
                            />
                          </div>

                          <div class="mb-3 col-12 col-md">
                            <label for="mom_surname"
                              >นามสกุล<span class="text-danger">*</span></label
                            >
                            <input
                              id="mom_surname"
                              type="text"
                              class="form-control mt-2"
                              :required="mom_status === 'เสียชีวิต'"
                            />
                          </div>
                        </div>

                        <div class="d-grid">
                          <label for="mom_death_certificate_file"
                            >แนบใบมรณะบัตร
                            <br />
                            <small class="text-secondary"
                              >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                class="text-danger"
                                >*</span
                              ></small
                            ></label
                          >
                          <input
                            type="file"
                            class="form-control"
                            @change="input_file_size_limit($event)"
                            id="mom_death_certificate_file"
                            accept=".pdf"
                            :required="mom_status === 'เสียชีวิต'"
                            v-if="!mom_death_certificate_file_useOld"
                          />
                        </div>
                        <div class="my-2" v-if="mom_death_certificate_file">
                          <div class="d-flex align-items-center gap-2">
                            <span>ใช้ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(mom_death_certificate_file)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="mom_death_certificate_file_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>

                      <!-- แนบหนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ -->
                      <div class="p-2" v-if="mom_status === 'ไม่ทราบข้อมูล'">
                        <div class="d-grid">
                          <label for="mom_family_status_certificate_file"
                            >แนบหนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ
                            <br />
                            <small class="text-secondary"
                              >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                class="text-danger"
                                >*</span
                              ></small
                            ></label
                          >
                          <input
                            type="file"
                            class="form-control"
                            @change="input_file_size_limit($event)"
                            id="mom_family_status_certificate_file"
                            accept=".pdf"
                            :required="mom_status === 'ไม่ทราบข้อมูล'"
                            v-if="!mom_family_status_certificate_file_useOld"
                          />
                          <div
                            class="my-2"
                            v-if="mom_family_status_certificate_file"
                          >
                            <div class="d-flex align-items-center gap-2">
                              <span>ใช้ไฟล์เก่า:</span>
                              <a
                                :href="
                                  getFileUrl(mom_family_status_certificate_file)
                                "
                                target="_blank"
                                rel="noopener noreferrer"
                                class="text-primary text-decoration-underline"
                              >
                                คลิกเพื่อดูไฟล์
                              </a>
                              <input
                                type="checkbox"
                                v-model="
                                  mom_family_status_certificate_file_useOld
                                "
                                class="form-check-input"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        id="mom_info_from"
                        v-if="mom_status === 'มีชีวิตอยู่'"
                      >
                        <div class="row">
                          <div class="mb-3 col">
                            <label for="mom_citizenShip" class="mb-2"
                              >สัญชาติ<span class="text-danger">*</span></label
                            >
                            <select
                              name="mom_citizenShip"
                              id="mom_citizenShip"
                              class="form-select w-50 mb-4"
                              v-model="mom_citizenShip"
                              required
                            >
                              <option selected value="ไทย">ไทย</option>
                              <option value="ต่างชาติ">ต่างชาติ</option>
                            </select>
                          </div>
                          <div class="mb-3 col-12 col-md"></div>
                        </div>

                        <div class="row">
                          <div
                            class="mb-3 col-12"
                            v-if="mom_citizenShip === 'ไทย'"
                          >
                            <label for="mom_citizenID"
                              >เลขบัตรประชาชน<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="mom_citizenID"
                              type="number"
                              @wheel.prevent
                              @keydown="input_number_block_mathsymbol"
                              @input="lenght_Validation($event, 13)"
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                            <div
                              class="mb-2"
                              v-if="
                                ![
                                  'ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร',
                                  'รายเก่า',
                                ].includes(user_studentType)
                              "
                            >
                              <label for="mom_citizenID_file"
                                >หนังสือยินยอมพร้อมสำเนาบัตรประชาชน<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                class="d-block w-50 form-control"
                                type="file"
                                @change="input_file_size_limit($event)"
                                name="mom_citizenID_file"
                                id="mom_citizenID_file"
                                accept=".pdf"
                                required
                                v-if="!mom_citizenID_file_useOld"
                              />
                              <div class="my-2" v-if="mom_citizenID_file">
                                <div class="d-flex align-items-center gap-2">
                                  <span>ใช้ไฟล์เก่า:</span>
                                  <a
                                    :href="getFileUrl(mom_citizenID_file)"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-primary text-decoration-underline"
                                  >
                                    คลิกเพื่อดูไฟล์
                                  </a>
                                  <input
                                    type="checkbox"
                                    v-model="mom_citizenID_file_useOld"
                                    class="form-check-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="mb-3 col-12"
                            v-if="mom_citizenShip === 'ต่างชาติ'"
                          >
                            <label for="mom_citizenID"
                              >เลขพาสปอร์ต<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="mom_citizenID"
                              type="text"
                              @wheel.prevent
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                            <div class="mb-2">
                              <label for="mom_citizenID_file"
                                >เอกสารสำเนาเลขพาสปอร์ต<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                class="d-block w-50 form-control"
                                type="file"
                                @change="input_file_size_limit($event)"
                                name="mom_citizenID_file"
                                id="mom_citizenID_file"
                                accept=".pdf"
                                required
                                v-if="!mom_citizenID_file_useOld"
                              />
                              <div class="my-2" v-if="mom_citizenID_file">
                                <div class="d-flex align-items-center gap-2">
                                  <span>ใช้ไฟล์เก่า:</span>
                                  <a
                                    :href="getFileUrl(mom_citizenID_file)"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-primary text-decoration-underline"
                                  >
                                    คลิกเพื่อดูไฟล์
                                  </a>
                                  <input
                                    type="checkbox"
                                    v-model="mom_citizenID_file_useOld"
                                    class="form-check-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="mb-3 col-12 col-md">
                            <label for="mom_old"
                              >อายุ<span class="text-danger">*</span></label
                            >
                            <input
                              id="mom_old"
                              type="number"
                              class="form-control mt-2"
                              @keydown="input_number_block_mathsymbol"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                          </div>
                        </div>

                        <div class="row">
                          <div class="mb-3 col">
                            <label for="mom_name"
                              >ชื่อ<span class="text-danger">*</span></label
                            >
                            <input
                              id="mom_name"
                              type="text"
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                          </div>

                          <div class="mb-3 col-12 col-md">
                            <label for="mom_surname"
                              >นามสกุล<span class="text-danger">*</span></label
                            >
                            <input
                              id="mom_surname"
                              type="text"
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                          </div>
                        </div>

                        <div class="row">
                          <div class="mb-3 col">
                            <label for="mom_phoneNumber"
                              >เบอร์โทรศัพท์เคลื่อนที่<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="mom_phoneNumber"
                              type="number"
                              @wheel.prevent
                              @keydown="input_number_block_mathsymbol"
                              @input="lenght_Validation($event, 10)"
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                          </div>

                          <div class="mb-3 col-12 col-md">
                            <label for="mom_email">อีเมล</label>
                            <input
                              id="mom_email"
                              type="email"
                              class="form-control mt-2"
                            />
                          </div>
                        </div>

                        <div class="row">
                          <div class="mb-3 col">
                            <label for="mom_job"
                              >ปัจจุบันประกอบอาชีพ<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="mom_job"
                              type="text"
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                            />
                          </div>

                          <div class="mb-3 col-12 col-md">
                            <label for="mom_income"
                              >มีรายได้บาท/ปี (ไม่หักค่าใช้จ่าย)<span
                                class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="mom_income"
                              type="text"
                              @wheel.prevent
                              @keydown="input_number_block_mathsymbol"
                              class="form-control mt-2"
                              :required="mom_status === 'มีชีวิตอยู่'"
                              @input="formatIncome('mom_income')"
                              v-model="displayIncome.mom_income"
                            />
                          </div>

                          <div class="mb-3">
                            <label for="mom_file"
                              >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนมารดา/บัตรสวัสดิการแห่งรัฐ") }}
                              <br />
                              <small class="text-secondary"
                                >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                  class="text-danger"
                                  >*</span
                                ></small
                              >
                            </label>
                            <input
                              id="mom_file"
                              type="file"
                              @change="input_file_size_limit($event)"
                              class="form-control mt-2 w-50"
                              accept=".pdf"
                              required
                              v-if="!momFile_useOld"
                            />
                            <div class="my-2" v-if="momFile">
                              <div class="d-flex align-items-center gap-2">
                                <span>ใช้ไฟล์เก่า:</span>
                                <a
                                  :href="getFileUrl(momFile)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="text-primary text-decoration-underline"
                                >
                                  คลิกเพื่อดูไฟล์
                                </a>
                                <input
                                  type="checkbox"
                                  v-model="momFile_useOld"
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bg-white mb-2 border border-2 rounded-1">
                    <h5 class="my-2 p-2">สถานภาพสมรสของบิดา-มารดา</h5>
                    <hr
                      style="border: none; height: 2px; background-color: black"
                    />
                    <select
                      name="Marital_status_of_parents"
                      id="Marital_status_of_parents"
                      class="form-select w-25 mb-4 ms-2"
                      v-model="Marital_status_of_parents"
                    >
                      <option selected disabled value="">กรุณาเลือก</option>
                      <option
                        value="สมรส"
                        v-if="
                          mom_status === 'มีชีวิตอยู่' ||
                          dad_status === 'มีชีวิตอยู่' ||
                          dad_status === 'เสียชีวิต' ||
                          mom_status === 'เสียชีวิต'
                        "
                      >
                        สมรส
                      </option>
                      <option
                        value="หย่าร้าง"
                        v-if="
                          mom_status === 'มีชีวิตอยู่' ||
                          dad_status === 'มีชีวิตอยู่' ||
                          dad_status === 'เสียชีวิต' ||
                          mom_status === 'เสียชีวิต'
                        "
                      >
                        หย่าร้าง
                      </option>
                      <option
                        value="แยกทางกันโดยมิได้จดทะเบียนสมรส"
                        v-if="
                          mom_status === 'มีชีวิตอยู่' ||
                          dad_status === 'มีชีวิตอยู่' ||
                          dad_status === 'เสียชีวิต' ||
                          mom_status === 'เสียชีวิต'
                        "
                      >
                        แยกทางกันโดยมิได้จดทะเบียนสมรส
                      </option>
                      <option
                        value="แยกทางกันโดยมิได้จดทะเบียนหย่า"
                        v-if="
                          mom_status === 'มีชีวิตอยู่' ||
                          dad_status === 'มีชีวิตอยู่' ||
                          dad_status === 'เสียชีวิต' ||
                          mom_status === 'เสียชีวิต'
                        "
                      >
                        แยกทางกันโดยมิได้จดทะเบียนหย่า
                      </option>
                      <option
                        value="ไม่ทราบ"
                        v-if="
                          !(
                            mom_status === 'มีชีวิตอยู่' ||
                            dad_status === 'มีชีวิตอยู่' ||
                            dad_status === 'เสียชีวิต' ||
                            mom_status === 'เสียชีวิต'
                          )
                        "
                      >
                        ไม่ทราบ
                      </option>
                    </select>
                    <div class="p-2" v-if="show_marriage_pdf">
                      <div class="d-grid">
                        <label for="Marital_status_of_parents_pdf"
                          >แนบใบหย่า /หนังสือรับรองสถานภาพครอบครัว
                          พร้อมสำเนาบัตรข้าราชการ
                          <br />
                          <small class="text-secondary"
                            >ไฟล์ PDF ขนาดไม่เกิน 10MB<span class="text-danger"
                              >*</span
                            ></small
                          ></label
                        >
                        <input
                          type="file"
                          class="form-control"
                          @change="input_file_size_limit($event)"
                          id="Marital_status_of_parents_file"
                          accept=".pdf"
                          :required="show_marriage_pdf"
                          v-if="!maritalFile_useOld"
                        />
                        <div class="my-2" v-if="maritalFile">
                          <div class="d-flex align-items-center gap-2">
                            <span>ใช้ไฟล์เก่า:</span>
                            <a
                              :href="getFileUrl(maritalFile)"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="text-primary text-decoration-underline"
                            >
                              คลิกเพื่อดูไฟล์
                            </a>
                            <input
                              type="checkbox"
                              v-model="maritalFile_useOld"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Rightful guardian -->
                  <div class="bg-white mb-2 border border-2 rounded-1">
                    <h5 class="my-2 p-2">
                      ผู้กู้ยืมอยู่ในความดูแลของ<span class="text-danger"
                        >*</span
                      >
                    </h5>
                    <hr
                      style="border: none; height: 2px; background-color: black"
                    />
                    <select
                      name="rightful_guardian"
                      id="rightful_guardian"
                      class="form-select w-25 mb-4 ms-2"
                      required
                      v-model="selectedGuardian"
                    >
                      <option selected disabled value="">กรุณาเลือก</option>
                      <option
                        value="บิดา มารดา"
                        v-if="
                          dad_status === 'มีชีวิตอยู่' &&
                          mom_status === 'มีชีวิตอยู่'
                        "
                      >
                        บิดา มารดา
                      </option>
                      <option
                        value="บิดาเพียงผู้เดียว"
                        v-if="dad_status === 'มีชีวิตอยู่'"
                      >
                        บิดาเพียงผู้เดียว
                      </option>
                      <option
                        value="มารดาเพียงผู้เดียว"
                        v-if="mom_status === 'มีชีวิตอยู่'"
                      >
                        มารดาเพียงผู้เดียว
                      </option>
                      <option value="ผู้ปกครองไม่ใช่บิดา มารดา">
                        ผู้ปกครองไม่ใช่บิดา มารดา
                      </option>
                    </select>
                    <div class="px-2">
                      <!-- Other -->
                      <div id="guardian_other_container">
                        <div id="other_info_from" v-if="showInput_other">
                          <div class="row">
                            <div class="mb-3 col">
                              <label for="other_citizenShip" class="mb-2"
                                >สัญชาติ<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <select
                                name="other_citizenShip"
                                id="other_citizenShip"
                                class="form-select w-50 mb-4"
                                v-model="other_citizenShip"
                                required
                              >
                                <option selected value="ไทย">ไทย</option>
                                <option value="ต่างชาติ">ต่างชาติ</option>
                              </select>
                            </div>
                            <div class="mb-3 col-12 col-md"></div>
                          </div>

                          <div class="row">
                            <div
                              class="mb-3 col-12"
                              v-if="other_citizenShip === 'ไทย'"
                            >
                              <label for="other_citizenID"
                                >เลขบัตรประชาชน<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="other_citizenID"
                                type="number"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                @input="lenght_Validation($event, 13)"
                                class="form-control mt-2"
                                :required="showInput_other"
                              />
                              <div
                                class="mb-2"
                                v-if="
                                  ![
                                    'ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร',
                                    'รายเก่า',
                                  ].includes(user_studentType)
                                "
                              >
                                <label for="other_citizenID_file"
                                  >หนังสือยินยอมพร้อมสำเนาบัตรประชาชน<span
                                    class="text-danger"
                                    >*</span
                                  ></label
                                >
                                <input
                                  class="d-block w-50 form-control"
                                  type="file"
                                  @change="input_file_size_limit($event)"
                                  name="other_citizenID_file"
                                  id="other_citizenID_file"
                                  accept=".pdf"
                                  required
                                  v-if="!other_citizenID_file_useOld"
                                />
                                <div class="my-2" v-if="other_citizenID_file">
                                  <div class="d-flex align-items-center gap-2">
                                    <span>ใช้ไฟล์เก่า:</span>
                                    <a
                                      :href="getFileUrl(other_citizenID_file)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary text-decoration-underline"
                                    >
                                      คลิกเพื่อดูไฟล์
                                    </a>
                                    <input
                                      type="checkbox"
                                      v-model="other_citizenID_file_useOld"
                                      class="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="mb-3 col-12"
                              v-if="other_citizenShip === 'ต่างชาติ'"
                            >
                              <label for="other_citizenID"
                                >เลขพาสปอร์ต<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="other_citizenID"
                                type="text"
                                @wheel.prevent
                                class="form-control mt-2"
                                :required="showInput_other"
                              />
                              <div class="mb-2">
                                <label for="other_citizenID_file"
                                  >เอกสารสำเนาเลขพาสปอร์ต<span
                                    class="text-danger"
                                    >*</span
                                  ></label
                                >
                                <input
                                  class="d-block w-50 form-control"
                                  type="file"
                                  @change="input_file_size_limit($event)"
                                  name="other_citizenID_file"
                                  id="other_citizenID_file"
                                  accept=".pdf"
                                  required
                                  v-if="!other_citizenID_file_useOld"
                                />
                                <div class="my-2" v-if="other_citizenID_file">
                                  <div class="d-flex align-items-center gap-2">
                                    <span>ใช้ไฟล์เก่า:</span>
                                    <a
                                      :href="getFileUrl(other_citizenID_file)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary text-decoration-underline"
                                    >
                                      คลิกเพื่อดูไฟล์
                                    </a>
                                    <input
                                      type="checkbox"
                                      v-model="other_citizenID_file_useOld"
                                      class="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="other_old"
                                >อายุ<span class="text-danger">*</span></label
                              >
                              <input
                                id="other_old"
                                type="number"
                                class="form-control mt-2"
                                @keydown="input_number_block_mathsymbol"
                                :required="showInput_other"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="other_name"
                                >ชื่อ<span class="text-danger">*</span></label
                              >
                              <input
                                id="other_name"
                                type="text"
                                class="form-control mt-2"
                                :required="showInput_other"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="other_surname"
                                >นามสกุล<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="other_surname"
                                type="text"
                                class="form-control mt-2"
                                :required="showInput_other"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="other_phoneNumber"
                                >เบอร์โทรศัพท์เคลื่อนที่<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="other_phoneNumber"
                                type="number"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                @input="lenght_Validation($event, 10)"
                                class="form-control mt-2"
                                :required="showInput_other"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="other_email">อีเมล</label>
                              <input
                                id="other_email"
                                type="email"
                                class="form-control mt-2"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="mb-3 col">
                              <label for="other_job"
                                >ปัจจุบันประกอบอาชีพ<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="other_job"
                                type="text"
                                class="form-control mt-2"
                                :required="showInput_other"
                              />
                            </div>

                            <div class="mb-3 col-12 col-md">
                              <label for="other_income"
                                >มีรายได้บาท/ปี (ไม่หักค่าใช้จ่าย)<span
                                  class="text-danger"
                                  >*</span
                                ></label
                              >
                              <input
                                id="other_income"
                                type="text"
                                @wheel.prevent
                                @keydown="input_number_block_mathsymbol"
                                class="form-control mt-2"
                                :required="showInput_other"
                                @input="formatIncome('other_income')"
                                v-model="displayIncome.other_income"
                              />
                            </div>
                          </div>

                          <div class="mb-3">
                            <label for="other_relationship"
                              >มีความเกี่ยวข้องเป็น<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              id="other_relationship"
                              type="text"
                              class="form-control mt-2 w-50"
                              :required="showInput_other"
                            />
                          </div>

                          <div class="mb-3">
                            <label for="other_file"
                              >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนผู้อุปการะ/บัตรสวัสดิการแห่งรัฐ") }}
                              <br />
                              <small class="text-secondary"
                                >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                  class="text-danger"
                                  >*</span
                                ></small
                              ></label
                            >
                            <input
                              id="other_file"
                              type="file"
                              @change="input_file_size_limit($event)"
                              class="form-control mt-2 w-50"
                              accept=".pdf"
                              :required="showInput_other"
                              v-if="!otherFile_useOld"
                            />
                            <div class="my-2" v-if="otherFile">
                              <div class="d-flex align-items-center gap-2">
                                <span>ใช้ไฟล์เก่า:</span>
                                <a
                                  :href="getFileUrl(otherFile)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="text-primary text-decoration-underline"
                                >
                                  คลิกเพื่อดูไฟล์
                                </a>
                                <input
                                  type="checkbox"
                                  v-model="otherFile_useOld"
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="mb-3">
                            <label for="other_file"
                              >หนังสือรับรองการเป็นผู้อุปการะที่ไม่ใช่บิดา-มารดาพร้อมสำเนาบัตรข้าราชการ
                              <br />
                              <small class="text-secondary"
                                >ไฟล์ PDF ขนาดไม่เกิน 10MB<span
                                  class="text-danger"
                                  >*</span
                                ></small
                              ></label
                            >
                            <input
                              id="other_NonParent_Custody_Certificate_file"
                              type="file"
                              @change="input_file_size_limit($event)"
                              class="form-control mt-2 w-50"
                              accept=".pdf"
                              :required="showInput_other"
                              v-if="!otherFile_certificate_useOld"
                            />
                            <div class="my-2" v-if="otherFile_certificate">
                              <div class="d-flex align-items-center gap-2">
                                <span>ไฟล์เก่า:</span>
                                <a
                                  :href="getFileUrl(otherFile_certificate)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="text-primary text-decoration-underline"
                                >
                                  คลิกเพื่อดูไฟล์
                                </a>
                                <input
                                  type="checkbox"
                                  v-model="otherFile_certificate_useOld"
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step 4 -->
                <div class="carousel-item px-3 py-2" id="form_step_4">
                  <div class="bg-white">
                    <div class="p-2">
                      <h5 class="my-auto p-2">
                        {{
                          user_studentType ===
                          "ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร"
                            ? "เหตุผลที่ไม่สามารถสำเร็จการศึกษาตามหลักสูตร"
                            : "เขียนบรรยายเหตุผลถึงความจำเป็นในการขอกู้ยืมเงิน"
                        }}
                      </h5>

                      <textarea
                        v-model="loanDescription"
                        class="form-control mt-2"
                        rows="25"
                        placeholder="กรอกคำบรรยายที่นี่ (ประมาณ 1 หน้ากระดาษ A4)..."
                        maxlength="3000"
                      ></textarea>
                      <small class="text-muted">
                        {{ loanDescription.length }} / 3000 ตัวอักษร (ประมาณ 1
                        หน้า A4)
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Step 5 -->
                <div class="carousel-item p-3 text-black">
                  <div class="bg-white">
                    <div class="p-2">
                      <h5 class="my-auto p-2">ข้อมูลคำขอ</h5>
                    </div>
                    <hr
                      style="border: none; height: 2px; background-color: black"
                      class="p-0 m-0"
                    />

                    <div class="loan-summary-modern p-3">
                      <div class="loan-summary-modern__hero shadow-sm">
                        <div>
                          <p class="loan-summary-modern__eyebrow mb-1">
                            สรุปก่อนส่งคำขอ
                          </p>
                          <h5 class="mb-2">ตรวจเฉพาะข้อมูลที่กรอกไว้จริง</h5>
                          <p class="loan-summary-modern__subtitle mb-0">
                            ระบบจะซ่อนข้อมูลที่ยังไม่ได้กรอก เพื่อให้อ่านง่ายและตรวจทานได้เร็วขึ้น
                          </p>
                        </div>

                        <div
                          v-if="step5SummaryHighlights.length"
                          class="loan-summary-modern__highlights"
                        >
                          <div
                            v-for="highlight in step5SummaryHighlights"
                            :key="highlight.label"
                            class="loan-summary-modern__highlight"
                          >
                            <span class="loan-summary-modern__highlight-label">{{
                              highlight.label
                            }}</span>
                            <strong class="loan-summary-modern__highlight-value">{{
                              highlight.value
                            }}</strong>
                          </div>
                        </div>
                      </div>

                      <div class="loan-summary-modern__grid">
                        <section
                          v-for="section in step5SummarySections"
                          :key="section.title"
                          class="loan-summary-card shadow-sm"
                          :class="{ 'loan-summary-card--wide': section.fullWidth }"
                        >
                          <div class="loan-summary-card__title">
                            {{ section.title }}
                          </div>

                          <p
                            v-if="section.description"
                            class="loan-summary-card__description"
                          >
                            {{ section.description }}
                          </p>

                          <div class="loan-summary-card__body">
                            <div
                              v-for="item in section.items"
                              :key="`${section.title}-${item.label}`"
                              class="loan-summary-field"
                            >
                              <div class="loan-summary-field__label">
                                {{ item.label }}
                              </div>

                              <div
                                v-if="item.chips && item.chips.length"
                                class="loan-summary-field__chips"
                              >
                                <span
                                  v-for="chip in item.chips"
                                  :key="`${item.label}-${chip}`"
                                  class="loan-summary-chip"
                                >
                                  {{ chip }}
                                </span>
                              </div>

                              <div
                                v-else-if="item.lines && item.lines.length"
                                class="loan-summary-field__lines"
                              >
                                <p
                                  v-for="line in item.lines"
                                  :key="`${item.label}-${line}`"
                                  class="mb-0"
                                >
                                  {{ line }}
                                </p>
                              </div>

                              <div v-else class="loan-summary-field__value">
                                {{ item.value }}
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>

                    <div v-show="false" aria-hidden="true">
                    <!-- User Info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลผู้กู้ยืมเงิน</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>ชื่อ-นามสกุล</b></p>
                              <p class="col" id="step5_user_fullname">-</p>
                            </div>
                          </div>

                          <div class="col-12 col-md">
                            <div class="row">
                              <p class="col"><b>อายุ</b></p>
                              <p class="col" id="step5_user_old">-</p>
                            </div>
                          </div>
                        </div>

                        <div class="row"></div>

                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>เบอร์โทรศัพท์เคลื่อนที่</b></p>
                              <p class="col" id="step5_user_phoneNumber">-</p>
                            </div>
                          </div>

                          <div class="col-12 col-md">
                            <div class="row">
                              <p class="col"><b>บัตรประชาชน</b></p>
                              <p class="col" id="step5_user_citizenID">-</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- User's education info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลการศึกษาที่ขอยื่นกู้</p>
                      <div class="bg-secondary-subtle">
                        <div class="p-3">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ระดับการศึกษา</b></p>
                                <p class="col" id="step5_user_lvlStudy">-</p>
                              </div>
                            </div>
                            <div class="col-12 col-md"></div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ปีการศึกษา</b></p>
                                <p class="col" id="step5_user_yearStudy">-</p>
                              </div>
                            </div>

                            <div class="col-12 col-md">
                              <div class="row">
                                <p class="col"><b>ภาคเรียน</b></p>
                                <p class="col" id="step5_user_semesterStudy">
                                  -
                                </p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>สถานภาพการเป็นนักศึกษา</b></p>
                                <div class="col-12 col-md">
                                  <p id="step5_user_studentStatus">-</p>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md">
                              <div class="row">
                                <p class="col"><b>ประเภทของผู้กู้ยืม</b></p>
                                <div class="col-12 col-md">
                                  <p id="step5_user_studentType">-</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr
                          style="
                            border: none;
                            height: 2px;
                            background-color: black;
                          "
                          class="p-0 m-0"
                        />

                        <div class="p-3">
                          <div class="row">
                            <div class="col-12 col-lg-11">
                              <div class="row step5-wide-row">
                                <p class="col-12 col-md-3"><b>สำนักวิชา</b></p>
                                <p
                                  class="col-12 col-md-9 step5-text-wrap"
                                  id="step5_user_faculty"
                                >
                                  -
                                </p>
                              </div>

                              <div class="row mt-1 step5-wide-row">
                                <p class="col-12 col-md-3">
                                  <b>สาขาวิชา</b>
                                </p>
                                <p
                                  class="col-12 col-md-9 step5-text-wrap"
                                  id="step5_user_fieldStudy"
                                >
                                  -
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr
                          style="
                            border: none;
                            height: 2px;
                            background-color: black;
                          "
                          class="p-0 m-0"
                        />

                        <div class="p-3">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>รหัสนักศึกษา</b></p>
                                <p class="col" id="step5_user_studentID">-</p>
                              </div>
                            </div>
                            <div class="col-12 col-md">
                              <div class="row">
                                <p class="col"><b>GPAX</b></p>
                                <p class="col" id="step5_user_gpax">-</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr
                          style="
                            border: none;
                            height: 2px;
                            background-color: black;
                          "
                          class="p-0 m-0"
                        />

                        <div class="p-3">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>จบการศึกษาระดับ</b></p>
                                <p class="col" id="step5_user_graduateLvl">-</p>
                              </div>
                            </div>
                            <div class="col-12 col-md"></div>
                          </div>
                        </div>

                        <hr
                          style="
                            border: none;
                            height: 2px;
                            background-color: black;
                          "
                          class="p-0 m-0"
                        />
                        <div class="px-3 mt-3">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col-6">
                                  <b
                                    >กิจกรรมจากเว็บไซต์ MFU CHARACTER (MFU333)
                                    จำนวน</b
                                  >
                                </p>
                                <p
                                  class="col"
                                  id="step5_Public_Service_Number_MFU333"
                                >
                                  -
                                </p>
                                <p class="col">ชั่วโมง</p>
                              </div>
                            </div>
                            <div class="col-12 col-md"></div>
                          </div>
                        </div>
                        <div class="px-3">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col-6">
                                  <b>กิจกรรมสร้างเอง จำนวน </b>
                                </p>
                                <p
                                  class="col"
                                  id="step5_Public_Service_Number_selfCreated"
                                >
                                  -
                                </p>
                                <p class="col">ชั่วโมง</p>
                              </div>
                            </div>
                            <div class="col-12 col-md"></div>
                          </div>
                        </div>
                        <div class="px-3">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col-6">
                                  <b
                                    >เรียน set e-learning, หลักสูตรอื่นๆ
                                    ที่กองทุนกำหนด จำนวน</b
                                  >
                                </p>
                                <p
                                  class="col"
                                  id="step5_Public_Service_Number_eLearning"
                                >
                                  -
                                </p>
                                <p class="col">ชั่วโมง</p>
                              </div>
                            </div>
                            <div class="col-12 col-md"></div>
                          </div>
                        </div>
                        <div class="px-3">
                          <div class="row">
                            <div class="col">
                              <p>รวม {{ totalPublicServiceNumber }} ชั่วโมง</p>
                            </div>
                            <div class="col-12 col-md"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- User's fiance info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลการเงิน</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col-6">
                                <b>ได้รับค่าใช้จ่ายในชีวิตประจำวัน</b>
                              </p>
                              <div class="col">
                                <div class="w-100">
                                  <div id="step5_dailyFee"></div>
                                  <div id="step5_job_block">
                                    <p class="mb-2 fw-semibold">
                                      จากการประกอบอาชีพ
                                    </p>
                                    <div class="row ms-4" id="step5_user_job_row">
                                      <p class="m-0 col-6">อาชีพ:</p>
                                      <p id="step5_user_job" class="m-0 col">
                                        -
                                      </p>
                                    </div>
                                    <div
                                      class="row ms-4"
                                      id="step5_user_job_income_row"
                                    >
                                      <p class="col-6">รายได้:</p>
                                      <p id="step5_user_job_income" class="col">
                                        -
                                      </p>
                                    </div>
                                  </div>
                                  <div id="step5_scholarship_block">
                                    <p class="mb-2 fw-semibold">ทุนการศึกษา</p>
                                    <div
                                      class="row ms-4"
                                      id="step5_user_scholarship_income_row"
                                    >
                                      <p class="m-0 col-6">
                                        ได้รับทุนการศึกษาจาก
                                      </p>
                                      <p
                                        id="step5_user_scholarship_income"
                                        class="m-0 col"
                                      >
                                        -
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- 📝 แสดงข้อมูลบัตรสวัสดิการแห่งรัฐ -->
                        <div
                          class="row"
                          id="step5_has_welfare_card_row"
                          v-if="user_studentType === 'รายใหม่'"
                        >
                          <div class="col">
                            <div class="row">
                              <p class="col-6"><b>ผู้กู้มีบัตรสวัสดิการแห่งรัฐ หรือไม่</b></p>
                              <p class="col" id="step5_has_welfare_card">-</p>
                            </div>
                          </div>
                        </div>

                        <!-- 📝 แสดงข้อมูลทุน กสศ. -->
                        <div
                          class="row"
                          id="step5_has_eef_scholarship_row"
                          v-if="user_studentType === 'รายใหม่'"
                        >
                          <div class="col">
                            <div class="row">
                              <p class="col-6"><b>ผู้กู้เคยรับทุนการศึกษา กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.) หรือไม่</b></p>
                              <p class="col" id="step5_has_eef_scholarship">-</p>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col">
                                <b>
                                  มีความประสงค์จะขอกู้ยืม<br />เพื่อใช้ในการศึกษา</b
                                >
                              </p>
                              <div class="col-12 col-md" id="step5_loanPurpose">
                                -
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col-6"><b>ลักษณะของผู้กู้ยืม</b></p>
                              <p class="col" id="step5_user_loanType">-</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- User's fan info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลสถานะภาพของผู้กู้ยืม</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>สถานะ</b></p>
                              <p class="col" id="step5_fan_status">-</p>
                            </div>
                          </div>

                          <div class="col"></div>
                        </div>

                        <div v-show="show_fan_info">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ชื่อ-นามสกุล</b></p>
                                <p class="col" id="step5_fan_fullname">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>เลขบัตรประชาชน</b></p>
                                <p class="col" id="step5_fan_citizenID">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อายุ</b></p>
                                <p class="col" id="step5_fan_old">-</p>
                              </div>
                            </div>
                            <div class="col"></div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col">
                                  <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                                </p>
                                <p class="col" id="step5_fan_phoneNumber">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อีเมล</b></p>
                                <p class="col" id="step5_fan_email">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อาชีพ</b></p>
                                <p class="col" id="step5_fan_job">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>มีรายได้บาท/ปี</b></p>
                                <p class="col" id="step5_fan_income">-</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Siblings Info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลพี่น้อง (ไม่รวมผู้กู้ยืม)</p>
                      <div
                        class="p-3 bg-secondary-subtle"
                        v-if="siblings && siblings.length"
                      >
                        <div
                          v-for="(sibling, idx) in siblings"
                          :key="idx"
                          class="mb-3 border-bottom pb-2"
                        >
                          <div class="fw-bold">พี่น้องคนที่ {{ idx + 1 }}</div>
                          <div>
                            สถานะ:
                            {{
                              sibling.status === "working"
                                ? "ทำงานแล้ว"
                                : sibling.status === "studying"
                                ? "กำลังศึกษา"
                                : "-"
                            }}
                          </div>
                          <div v-if="sibling.status === 'working'">
                            อาชีพ: {{ sibling.job || "-" }}<br />
                            รายได้ต่อปี: {{ sibling.income || "-" }}
                          </div>
                          <div v-if="sibling.status === 'studying'">
                            ระดับการศึกษา: {{ sibling.educationLevel || "-" }}
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-muted p-3 bg-secondary-subtle">
                        -
                      </div>
                    </div>

                    <!-- User's father info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลบิดา</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>สถานะ</b></p>
                              <p class="col" id="step5_dad_status">-</p>
                            </div>
                          </div>

                          <div class="col"></div>
                        </div>

                        <div v-if="dad_status === 'เสียชีวิต'">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ชื่อ-นามสกุล</b></p>
                                <p class="col" id="step5_dad_fullname_deceased">-</p>
                              </div>
                            </div>

                            <div class="col"></div>
                          </div>
                        </div>

                        <div v-show="dad_status === 'มีชีวิตอยู่'">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ชื่อ-นามสกุล</b></p>
                                <p class="col" id="step5_dad_fullname_alive">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>เลขบัตรประชาชน</b></p>
                                <p class="col" id="step5_dad_citizenID">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อายุ</b></p>
                                <p class="col" id="step5_dad_old">-</p>
                              </div>
                            </div>
                            <div class="col"></div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col">
                                  <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                                </p>
                                <p class="col" id="step5_dad_phoneNumber">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อีเมล</b></p>
                                <p class="col" id="step5_dad_email">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อาชีพ</b></p>
                                <p class="col" id="step5_dad_job">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>มีรายได้บาท/ปี</b></p>
                                <p class="col" id="step5_dad_income">-</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- User's mother info -->
                    <div class="p-3">
                      <p class="text-secondary">ข้อมูลมารดา</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>สถานะ</b></p>
                              <p class="col" id="step5_mom_status">-</p>
                            </div>
                          </div>

                          <div class="col"></div>
                        </div>

                        <div v-if="mom_status === 'เสียชีวิต'">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ชื่อ-นามสกุล</b></p>
                                <p class="col" id="step5_mom_fullname_deceased">-</p>
                              </div>
                            </div>

                            <div class="col"></div>
                          </div>
                        </div>

                        <div v-show="mom_status === 'มีชีวิตอยู่'">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ชื่อ-นามสกุล</b></p>
                                <p class="col" id="step5_mom_fullname_alive">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>เลขบัตรประชาชน</b></p>
                                <p class="col" id="step5_mom_citizenID">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อายุ</b></p>
                                <p class="col" id="step5_mom_old">-</p>
                              </div>
                            </div>
                            <div class="col"></div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col">
                                  <b>เบอร์โทรศัพท์เคลื่อนที่ </b>
                                </p>
                                <p class="col" id="step5_mom_phoneNumber">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อีเมล</b></p>
                                <p class="col" id="step5_mom_email">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อาชีพ</b></p>
                                <p class="col" id="step5_mom_job">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>มีรายได้บาท/ปี</b></p>
                                <p class="col" id="step5_mom_income">-</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- dad mom mariage info -->
                    <div class="p-3">
                      <p class="text-secondary">สถานภาพสมรสของบิดา-มารดา</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>สถานะ</b></p>
                              <p class="col" id="step5_mariage_status">-</p>
                            </div>
                          </div>
                          <div class="col"></div>
                        </div>
                      </div>
                    </div>

                    <!-- User's rightful guardian info -->
                    <div class="p-3">
                      <p class="text-secondary">
                        ข้อมูลผู้แทนโดยชอบธรรม/ผู้ปกครอง
                      </p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <p class="col"><b>มีความเกี่ยวข้องเป็น</b></p>
                              <p class="col" id="step5_rightful_guardian">-</p>
                            </div>
                          </div>
                          <div class="col"></div>
                        </div>

                        <div v-show="show_other_info">
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>ชื่อ-นามสกุล</b></p>
                                <p class="col" id="step5_other_fullname">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>เลขบัตรประชาชน</b></p>
                                <p class="col" id="step5_other_citizenID">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อายุ</b></p>
                                <p class="col" id="step5_other_old">-</p>
                              </div>
                            </div>
                            <div class="col"></div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col">
                                  <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                                </p>
                                <p class="col" id="step5_other_phoneNumber">
                                  -
                                </p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อีเมล</b></p>
                                <p class="col" id="step5_other_email">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col"><b>อาชีพ</b></p>
                                <p class="col" id="step5_other_job">-</p>
                              </div>
                            </div>

                            <div class="col">
                              <div class="row">
                                <p class="col"><b>มีรายได้บาท/ปี</b></p>
                                <p class="col" id="step5_other_income">-</p>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <p class="col-3"><b>มีความเกี่ยวข้องเป็น</b></p>
                                <p class="col" id="step5_other_relationship">
                                  -
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- description info -->
                    <!-- Step 5 -->
                    <div class="p-3">
                      <p class="text-secondary">คำบรรยาย</p>
                      <div class="p-3 bg-secondary-subtle">
                        <div class="col">
                          <div class="row">
                            <p
                              class="col"
                              id="step5_description"
                              style="
                                white-space: pre-wrap;
                                word-break: break-word;
                              "
                            >
                              {{ loanDescription || "-" }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>

                <!-- Step 6 -->
                <div class="carousel-item p-3 text-black">
                  <div class="bg-white text-center p-4">
                    <i
                      class="fa-solid fa-check"
                      style="color: #00ff00; font-size: 150px"
                    ></i>
                    <h4>เสร็จสิ้น</h4>
                    <p>คำขอกู้ของคุณถูกส่งไปยังเจ้าหน้าที่แล้ว</p>
                    <p>เจ้าหน้าที่จะทำการตรวจข้อมูลคำขอของคุณ</p>
                  </div>
                </div>
              </div>

              <!-- Next and Back button -->
              <div class="from_button_control row mt-3 px-3">
                <div class="col">
                  <button
                    v-if="step > 1 || step < 5"
                    class="btn btn-outline-info d-flex align-items-center float-start px-3 py-2"
                    type="button"
                    data-bs-target="#LoanForm"
                    data-bs-slide="prev"
                    @click="
                      disabledButton();
                      deleteStep();
                    "
                    :disabled="step === 1 || step === 6 || buttonStatus"
                  >
                    <span>ย้อนกลับ</span>
                  </button>
                </div>

                <div class="col">
                  <!-- Next button -->
                  <div v-if="step < 5">
                    <button
                      class="btn d-flex align-items-center float-end px-4 py-2"
                      type="button"
                      style="background-color: #964040"
                      @click="
                        disabledButton();
                        input_validation_check();
                      "
                      :disabled="buttonStatus || step === 5"
                    >
                      <span class="text-white">ถัดไป</span>
                    </button>
                  </div>
                  <!-- Submit button -->
                  <div v-if="step === 5">
                    <button
                      class="btn btn-info d-flex align-items-center float-end px-4 py-2"
                      :disabled="buttonStatus || step < 5"
                      @click="
                        disabledButton();
                        confirmBoxForm();
                      "
                    >
                      <span>ส่งคำร้องขอ</span>
                    </button>
                  </div>
                  <div v-if="step === 6">
                    <button
                      class="btn btn-info d-flex align-items-center float-end px-4 py-2"
                      :disabled="buttonStatus || step < 6"
                      @click="this.$router.push('/user')"
                    >
                      <span>กลับสู่หน้าหลัก</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/User/NavBar_user.vue";
import { Carousel } from "bootstrap";
import AlertBox from "../AlertBox.vue";
import Swal from "sweetalert2";
import { applyOldFileFields } from "@/utils/loanFormFiles";

export default {
  name: "UserPage_loan",
  components: {
    NavBar,
    AlertBox,
  },

  data() {
    return {
      // session
      studentID: "",
      // For from
      isSubmitting: false,
      formID: null, // For form edit
      step: 1, // from step 1-5
      studyYear: new Date().getFullYear() + 543,
      studySemester: 1,
      user_lvlStudy: null,
      user_studentStatus: "",
      user_studentType: "",
      educationLevelOptions: [],
      buttonStatus: false,
      finance_income_checkbox: false,
      scholarship_income_checkbox: false,
      PublicServiceNumber_Needed: 36,

      formData: {
        user_job: "",
        user_job_income: "",
        user_graduateLvl: "",
        fan_income: "",
        dad_income: "",
        mom_income: "",
        other_income: "",
        Public_Service_Number_MFU333: 0,
        Public_Service_Number_selfCreated: 0,
        Public_Service_Number_eLearning: 0,
        has_welfare_card: "",
        has_eef_scholarship: "",
      },

      displayIncome: {
        user_job_income: "0",
        fan_income: "0",
        dad_income: "0",
        mom_income: "0",
        other_income: "0",
      },

      showInput_fan: false,
      fan_citizenShip: "ไทย",
      show_fan_info: false,
      fan_unknown: false,

      dad_citizenShip: "ไทย",
      mom_citizenShip: "ไทย",
      showInput_other: false,
      other_citizenShip: "ไทย",
      dad_status: "",
      mom_status: "",
      show_other_info: false,
      show_marriage_pdf: false,
      selectedGuardian: "",
      Marital_status_of_parents: "",
      graduatedLevelOptions: [],

      // For Validation
      UserForm: [],
      user_scholarship_income: "",

      siblingsCount: 0,
      siblings: [],

      // Queried file
      user_transcript_file: null,
      user_studentCertificate_file: null,
      user_courseCertificate_file: null,
      user_gpax_file: null,
      user_citizenID_file: null,
      income_file: null,
      fan_citizenID_file: null,
      fan_income_file: null,
      fanFile: null,

      dadFile: null,
      momFile: null,
      otherFile: null,
      publicFile: null,
      Public_Service_MFU333_File: null,
      Public_Service_selfCreated_File: null,
      Public_Service_eLearning_File: null,
      maritalFile: null,
      otherFile_certificate: null,
      dad_death_certificate_file: null,
      mom_death_certificate_file: null,
      dad_family_status_certificate_file: null,
      mom_family_status_certificate_file: null,
      dad_citizenID_file: null,
      mom_citizenID_file: null,
      other_citizenID_file: null,

      user_imageFile: null,
      welfare_card_file: null,
      eef_scholarship_file: null,

      loanDescription: "",
      step5SummarySections: [],
      step5SummaryHighlights: [],

      // handle edit file
      user_transcript_file_useOld: null,
      user_studentCertificate_file_useOld: null,
      user_courseCertificate_file_useOld: null,
      user_gpax_file_useOld: null,
      income_file_useOld: null,
      fan_income_file_useOld: false,
      fanFile_useOld: false,
      dadFile_useOld: false,
      momFile_useOld: false,
      otherFile_useOld: false,
      publicFile_useOld: false,
      Public_Service_MFU333_File_useOld: false,
      Public_Service_selfCreated_File_useOld: false,
      Public_Service_eLearning_File_useOld: false,
      maritalFile_useOld: false,
      otherFile_certificate_useOld: false,
      dad_death_certificate_file_useOld: false,
      mom_death_certificate_file_useOld: false,
      dad_family_status_certificate_file_useOld: false,
      mom_family_status_certificate_file_useOld: false,
      user_citizenID_file_useOld: false,
      fan_citizenID_file_useOld: false,
      dad_citizenID_file_useOld: false,
      mom_citizenID_file_useOld: false,
      other_citizenID_file_useOld: false,
      user_imageFile_useOld: false,
      welfare_card_file_useOld: false,
      eef_scholarship_file_useOld: false,

      previewUrl: null,
      isMockMode: process.env.VUE_APP_ENABLE_MOCK_DATA === "true" || process.env.VUE_APP_BYPASS_AUTH === "true",
      isMockFilling: false,
    };
  },

  //   data() {
  //   return {
  //     studentID: "",
  //     isSubmitting: false,
  //     formID: null,
  //     step: 1,
  //     studyYear: new Date().getFullYear() + 543,
  //     studySemester: 1,
  //     buttonStatus: false,
  //     finance_income_checkbox: false,
  //     scholarship_income_checkbox: false,
  //     PublicServiceNumber_Needed: 1,

  //     showInput_fan: false,
  //     fan_citizenShip: "ไทย",
  //     show_fan_info: false,
  //     fan_unknown: false,

  //     dad_citizenShip: "ไทย",
  //     mom_citizenShip: "ไทย",
  //     showInput_other: false,
  //     other_citizenShip: "ไทย",
  //     show_other_info: false,
  //     show_marriage_pdf: false,
  //     selectedGuardian: "",

  //     // The merged formData object
  //     formData: {
  //       // User info
  //       user_username: "",
  //       user_surname: "",
  //       user_old: "",
  //       user_phoneNumber: "",
  //       user_citizenID: "",
  //       user_lvlStudy: "",
  //       user_yearStudy: "",
  //       user_semesterStudy: "",
  //       user_studentStatus: "",
  //       user_studentType: "",
  //       user_faculty: "",
  //       user_fieldStudy: "",
  //       user_studentID: "",
  //       user_gpax: "",
  //       user_graduateLvl: "",
  //       Public_Service_Number: "",
  //       user_loanType: "",
  //       user_job: "",
  //       user_job_income: "",
  //       user_scholarship_income: "",

  //       // Fan info
  //       fan_status: "",
  //       fan_name: "",
  //       fan_surname: "",
  //       fan_citizenID: "",
  //       fan_old: "",
  //       fan_phoneNumber: "",
  //       fan_email: "",
  //       fan_job: "",
  //       fan_income: "",

  //       // Dad info
  //       dad_status: "",
  //       dad_name: "",
  //       dad_surname: "",
  //       dad_citizenID: "",
  //       dad_old: "",
  //       dad_phoneNumber: "",
  //       dad_email: "",
  //       dad_job: "",
  //       dad_income: "",

  //       // Mom info
  //       mom_status: "",
  //       mom_name: "",
  //       mom_surname: "",
  //       mom_citizenID: "",
  //       mom_old: "",
  //       mom_phoneNumber: "",
  //       mom_email: "",
  //       mom_job: "",
  //       mom_income: "",

  //       // Other guardian info
  //       Marital_status_of_parents: "",
  //       other_name: "",
  //       other_surname: "",
  //       other_citizenID: "",
  //       other_old: "",
  //       other_phoneNumber: "",
  //       other_email: "",
  //       other_job: "",
  //       other_income: "",
  //       other_relationship: "",
  //       rightful_guardian: "",

  //       // Other
  //       description: "",
  //       siblings: [],
  //       loanDescription: "",

  //       // All file uploads merged here
  //       user_transcript_file: null,
  //       user_studentCertificate_file: null,
  //       user_courseCertificate_file: null,
  //       user_gpax_file: null,
  //       user_citizenID_file: null,
  //       income_file: null,
  //       fan_citizenID_file: null,
  //       fan_income_file: null,
  //       fanFile: null,
  //       dadFile: null,
  //       momFile: null,
  //       otherFile: null,
  //       publicFile: null,
  //       maritalFile: null,
  //       otherFile_certificate: null,
  //       dad_death_certificate_file: null,
  //       mom_death_certificate_file: null,
  //       dad_family_status_certificate_file: null,
  //       mom_family_status_certificate_file: null,
  //       dad_citizenID_file: null,
  //       mom_citizenID_file: null,
  //       other_citizenID_file: null,
  //       user_imageFile: null,
  //     },

  //     // For validation and other logic
  //     UserForm: [],
  //     user_studentStatus: "",
  //     user_studentType: "",
  //     user_job: "",
  //     user_job_income: "",
  //     user_scholarship_income: "",
  //     siblingsCount: 0,
  //     siblings: [],

  //     // Flags for using old files
  //     user_transcript_file_useOld: null,
  //     user_studentCertificate_file_useOld: null,
  //     user_courseCertificate_file_useOld: null,
  //     user_gpax_file_useOld: null,
  //     income_file_useOld: null,
  //     fan_income_file_useOld: false,
  //     fanFile_useOld: false,
  //     dadFile_useOld: false,
  //     momFile_useOld: false,
  //     otherFile_useOld: false,
  //     publicFile_useOld: false,
  //     maritalFile_useOld: false,
  //     otherFile_certificate_useOld: false,
  //     dad_death_certificate_file_useOld: false,
  //     mom_death_certificate_file_useOld: false,
  //     dad_family_status_certificate_file_useOld: false,
  //     mom_family_status_certificate_file_useOld: false,
  //     user_citizenID_file_useOld: false,
  //     fan_citizenID_file_useOld: false,
  //     dad_citizenID_file_useOld: false,
  //     mom_citizenID_file_useOld: false,
  //     other_citizenID_file_useOld: false,
  //     user_imageFile_useOld: false,

  //     previewUrl: null
  //   };
  // },

  methods: {
    ncbDocumentLabel(label) {
      return this.user_studentType === "รายใหม่" ? `${label}และNCB` : label;
    },

    setFieldValue(id, value) {
      const element = document.getElementById(id);
      if (!element) return;

      element.value = value;
      element.dispatchEvent(new Event("input", { bubbles: true }));
      element.dispatchEvent(new Event("change", { bubbles: true }));
    },

    setSelectValue(id, value) {
      const element = document.getElementById(id);
      if (!element) return;

      const hasOption = Array.from(element.options || []).some(
        (option) => option.value === value
      );

      if (!hasOption) {
        const option = document.createElement("option");
        option.value = value;
        option.text = value;
        element.appendChild(option);
      }

      element.value = value;
      element.dispatchEvent(new Event("input", { bubbles: true }));
      element.dispatchEvent(new Event("change", { bubbles: true }));
    },

    setCheckboxValue(id, checked = true) {
      const element = document.getElementById(id);
      if (!element) return;

      element.checked = checked;
      element.dispatchEvent(new Event("change", { bubbles: true }));
    },

    setOldMockFile(fieldName, filePath) {
      this[fieldName] = filePath;

      const useOldField = `${fieldName}_useOld`;
      if (Object.prototype.hasOwnProperty.call(this.$data, useOldField)) {
        this[useOldField] = true;
      }

      if (fieldName === "user_imageFile") {
        this.previewUrl = this.getFileUrl(filePath);
      }
    },

    syncProgressToStep(targetStep) {
      const carousel = document.querySelector("#LoanForm");
      const carouselInstance =
        Carousel.getInstance(carousel) || new Carousel(carousel);

      for (let i = 2; i <= 6; i++) {
        const stepElement = document.querySelector(`.pgs-step-${i}`);
        const labelElement = document.querySelector(`.sl-step-${i}`);
        const isActive = i <= targetStep;

        stepElement?.classList.toggle("active", isActive);
        labelElement?.classList.toggle("active", isActive);
      }

      this.step = targetStep;
      carouselInstance.to(targetStep - 1);
      this.scrollToFormTop();
    },

    // Helper function to create mock files
    async createMockPdfFile(fileName = "mock_document.pdf") {
      const blob = new Blob(
        ["%PDF-1.4\n1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] >>\nendobj\nxref\n0 4\ntrailer\n<< /Size 4 /Root 1 0 R >>\nstartxref\n%%EOF"],
        { type: "application/pdf" }
      );
      return new File([blob], fileName, { type: "application/pdf" });
    },

    async createMockImageFile(fileName = "mock_photo.jpg") {
      // Create a small base64 encoded image (1x1 red pixel)
      const base64 = "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8DwHwAFBQIAX8jx0gAAAABJRU5ErkJggg==";
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/jpeg" });
      return new File([blob], fileName, { type: "image/jpeg" });
    },

    async fillMockDataUntilStep5() {
      if (this.isMockFilling) return;

      this.isMockFilling = true;

      const mockFaculty = "สำนักวิชาเทคโนโลยีดิจิทัลประยุกต์";
      const mockFieldStudy =
        "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมซอฟต์แวร์";

      try {
        // Create mock files
        const mockPdfFile = await this.createMockPdfFile();
        const mockImageFile = await this.createMockImageFile();
        await Promise.all([
          this.getDailyExpensesOptions(),
          this.getLoanPurposesOptions(),
          this.getEdu_lvl(),
          this.getFaculty(),
          this.getGraduatedLevel(),
        ]);

        this.user_lvlStudy = "ปริญญาตรี";
        this.user_studentType = "รายเก่า";
        this.user_studentStatus = "ปกติ";
        this.updateNeededHours();

        await this.$nextTick();
        this.setSelectValue("user_lvlStudy", this.user_lvlStudy);
        this.setSelectValue("user_yearStudy", String(this.studyYear));
        this.setSelectValue("user_semesterStudy", String(this.studySemester));

        this.setSelectValue("user_faculty", mockFaculty);
        await this.getStudyField(mockFaculty);
        await this.$nextTick();
        this.setSelectValue("user_fieldStudy", mockFieldStudy);
        this.setSelectValue("user_loanType", "ลักษณะที่ 1");
        this.setSelectValue("user_studentStatus", this.user_studentStatus);
        this.setFieldValue("user_gpax", "3.42");

        // Set GPAX file
        this.user_gpax_file = mockPdfFile;
        const gpaxFileInput = document.getElementById("user_gpax_file");
        if (gpaxFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          gpaxFileInput.files = dataTransfer.files;
        }

        // Set user image file
        this.user_imageFile = mockImageFile;
        this.previewUrl = URL.createObjectURL(mockImageFile);
        const userImageFileInput = document.getElementById("user_imageFile");
        if (userImageFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockImageFile);
          userImageFileInput.files = dataTransfer.files;
        }

        this.setFieldValue("user_username", "สมชาย");
        this.setFieldValue("user_surname", "ตัวอย่าง");
        this.setFieldValue("user_old", "20");
        this.setFieldValue("user_phoneNumber", "0812345678");
        this.setFieldValue("user_citizenID", "1103700000001");
        
        // Set citizen ID file
        this.user_citizenID_file = mockPdfFile;
        const citizenIdFileInput = document.getElementById("user_citizenID_file");
        if (citizenIdFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          citizenIdFileInput.files = dataTransfer.files;
        }

        this.setSelectValue("user_graduateLvl", "ปริญญาตรี");

        this.setCheckboxValue("จากผู้ปกครอง", true);
        this.setCheckboxValue("ค่าเล่าเรียน", true);
        this.formData.user_job = "";
        this.formData.user_job_income = 0;
        this.displayIncome.user_job_income = "0";
        this.user_scholarship_income = "";

        this.formData.Public_Service_Number_MFU333 = 36;
        this.formData.Public_Service_Number_selfCreated = 0;
        this.formData.Public_Service_Number_eLearning = 0;
        
        // Set Public Service file
        this.Public_Service_MFU333_File = mockPdfFile;
        const publicServiceFileInput = document.getElementById("Public_Service_MFU333_File");
        if (publicServiceFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          publicServiceFileInput.files = dataTransfer.files;
        }

        this.setSelectValue("fan_status", "โสด");
        this.checkFanStatus({ target: { value: "โสด" } });

        this.setFieldValue("siblings_count", "0");
        this.handleSiblingsCountChange({ target: { value: "0" } });

        // Mock data for welfare card and EEF scholarship
        this.formData.has_welfare_card = "มี";
        this.welfare_card_file = mockPdfFile;
        const welfareFileInput = document.getElementById("welfare_card_file");
        if (welfareFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          welfareFileInput.files = dataTransfer.files;
        }

        this.formData.has_eef_scholarship = "เคย";
        this.eef_scholarship_file = mockPdfFile;
        const eefFileInput = document.getElementById("eef_scholarship_file");
        if (eefFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          eefFileInput.files = dataTransfer.files;
        }

        this.dad_status = "มีชีวิตอยู่";
        this.mom_status = "มีชีวิตอยู่";
        await this.$nextTick();
        this.setSelectValue("dad_status", this.dad_status);
        this.setSelectValue("mom_status", this.mom_status);

        this.setFieldValue("dad_citizenID", "1103700000002");
        
        // Set dad citizen ID file
        this.dad_citizenID_file = mockPdfFile;
        const dadCitizenIdFileInput = document.getElementById("dad_citizenID_file");
        if (dadCitizenIdFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          dadCitizenIdFileInput.files = dataTransfer.files;
        }
        
        this.setFieldValue("dad_old", "50");
        this.setFieldValue("dad_name", "วิชัย");
        this.setFieldValue("dad_surname", "ตัวอย่าง");
        this.setFieldValue("dad_phoneNumber", "0823456789");
        this.setFieldValue("dad_email", "dad@example.com");
        this.setFieldValue("dad_job", "รับราชการ");
        this.displayIncome.dad_income = "240,000";
        this.formData.dad_income = 240000;
        
        // Set dad income file
        this.dadFile = mockPdfFile;
        const dadFileInput = document.getElementById("dad_file");
        if (dadFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          dadFileInput.files = dataTransfer.files;
        }

        this.setFieldValue("mom_citizenID", "1103700000003");
        
        // Set mom citizen ID file
        this.mom_citizenID_file = mockPdfFile;
        const momCitizenIdFileInput = document.getElementById("mom_citizenID_file");
        if (momCitizenIdFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          momCitizenIdFileInput.files = dataTransfer.files;
        }
        
        this.setFieldValue("mom_old", "48");
        this.setFieldValue("mom_name", "สุดา");
        this.setFieldValue("mom_surname", "ตัวอย่าง");
        this.setFieldValue("mom_phoneNumber", "0834567890");
        this.setFieldValue("mom_email", "mom@example.com");
        this.setFieldValue("mom_job", "ค้าขาย");
        this.displayIncome.mom_income = "180,000";
        this.formData.mom_income = 180000;
        
        // Set mom income file
        this.momFile = mockPdfFile;
        const momFileInput = document.getElementById("mom_file");
        if (momFileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(mockPdfFile);
          momFileInput.files = dataTransfer.files;
        }

        this.Marital_status_of_parents = "สมรส";
        this.selectedGuardian = "บิดา มารดา";
        await this.$nextTick();
        this.setSelectValue(
          "Marital_status_of_parents",
          this.Marital_status_of_parents
        );
        this.setSelectValue("rightful_guardian", this.selectedGuardian);

        this.loanDescription =
          "ต้องการใช้เป็นค่าเล่าเรียนและค่าใช้จ่ายที่เกี่ยวข้องกับการศึกษาในภาคการศึกษานี้";

        await this.$nextTick();
        Object.assign(this.UserForm, {
          user_lvlStudy: this.user_lvlStudy,
          user_yearStudy: this.studyYear,
          user_semesterStudy: this.studySemester,
          user_faculty: mockFaculty,
          user_fieldStudy: mockFieldStudy,
          user_studentType: this.user_studentType,
          user_loanType: "ลักษณะที่ 1",
          user_studentStatus: this.user_studentStatus,
          user_studentID: this.studentID,
          user_gpax: "3.42",
          user_username: "สมชาย",
          user_surname: "ตัวอย่าง",
          user_old: "20",
          user_phoneNumber: "0812345678",
          user_citizenID: "1103700000001",
          user_graduateLvl: "ปริญญาตรี",
          dailyFee: ["จากผู้ปกครอง"],
          loanPurpose: ["ค่าเล่าเรียน"],
          Public_Service_Number_MFU333: 36,
          Public_Service_Number_selfCreated: 0,
          Public_Service_Number_eLearning: 0,
          fan_status: "โสด",
          dad_status: this.dad_status,
          mom_status: this.mom_status,
          dad_citizenID: "1103700000002",
          dad_old: "50",
          dad_name: "วิชัย",
          dad_surname: "ตัวอย่าง",
          dad_phoneNumber: "0823456789",
          dad_email: "dad@example.com",
          dad_job: "รับราชการ",
          dad_income: 240000,
          mom_citizenID: "1103700000003",
          mom_old: "48",
          mom_name: "สุดา",
          mom_surname: "ตัวอย่าง",
          mom_phoneNumber: "0834567890",
          mom_email: "mom@example.com",
          mom_job: "ค้าขาย",
          mom_income: 180000,
          Marital_status_of_parents: this.Marital_status_of_parents,
          rightful_guardian: this.selectedGuardian,
          siblings: JSON.stringify([]),
          description: this.loanDescription,
          has_welfare_card: this.formData.has_welfare_card,
          has_eef_scholarship: this.formData.has_eef_scholarship,
        });
        this.step_5_show_data();
        this.setFieldValue("user_lvlStudy", this.user_lvlStudy);
        this.setSelectValue("user_faculty", mockFaculty);
        this.setSelectValue("user_fieldStudy", mockFieldStudy);
        const step5Faculty = document.getElementById("step5_user_faculty");
        const step5FieldStudy = document.getElementById("step5_user_fieldStudy");
        if (step5Faculty) {
          step5Faculty.innerText = mockFaculty;
        }
        if (step5FieldStudy) {
          step5FieldStudy.innerText = mockFieldStudy;
        }
        this.syncProgressToStep(5);
        this.$refs.alertBox.showAlert(
          "ใส่ข้อมูลทดสอบให้แล้วถึงหน้า 5",
          "success"
        );
      } catch (error) {
        console.error(error);
        this.$refs.alertBox.showAlert(
          "ใส่ข้อมูลทดสอบไม่สำเร็จ",
          "error"
        );
      } finally {
        this.isMockFilling = false;
      }
    },

    handleSiblingsCountChange(event) {
      const count = parseInt(event.target.value, 10) || 0;
      this.siblingsCount = count;

      // ปรับขนาด Array siblings ให้เท่ากับจำนวนที่ผู้ใช้กรอก
      if (count > this.siblings.length) {
        // เพิ่มช่องใหม่ถ้าจำนวนใหม่มากกว่าเดิม
        for (let i = this.siblings.length; i < count; i++) {
          this.siblings.push({
            status: "",
            job: "",
            income: null,
            educationLevel: "",
          });
        }
      } else {
        // ลบออกถ้าจำนวนน้อยลง
        this.siblings.splice(count);
      }
    },

    handleSiblingStatusChange(index) {
      const sibling = this.siblings[index];
      if (sibling.status === "working") {
        // เคลียร์ข้อมูลของ studying ถ้ามาเลือก working
        sibling.educationLevel = "";
      } else if (sibling.status === "studying") {
        // เคลียร์ข้อมูลของ working ถ้ามาเลือก studying
        sibling.job = "";
        sibling.income = null;
      }
    },
    previewImage(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        this.previewUrl = URL.createObjectURL(file);
      } else {
        this.previewUrl = null;
      }
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        this.previewUrl = null;
        return;
      }
      this.user_imageFile_useOld = false; // เมื่ออัพโหลดใหม่ เลือกไม่ใช้ไฟล์เก่า
      this.user_imageFile = null; // ล้างไฟล์เก่าออกถ้ามี
      // สร้าง URL สำหรับ preview
      this.previewUrl = URL.createObjectURL(file);
    },

    async APIsentForm() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      try {
        const formData = new FormData();
        const fileAliasMap = {
          dadFile: "dad_file",
          momFile: "mom_file",
          fanFile: "fan_file",
          otherFile: "other_file",
          maritalFile: "Marital_status_of_parents_file",
          otherFile_certificate: "other_NonParent_Custody_Certificate_file",
        };
        const normalizedUserForm = {};

        Object.entries(this.UserForm).forEach(([key, value]) => {
          const normalizedKey = fileAliasMap[key] || key;
          normalizedUserForm[normalizedKey] = value;
        });

        for (const key in normalizedUserForm) {
          const value = normalizedUserForm[key];
          if (value !== null && value !== undefined && value !== "") {
            if (Array.isArray(value)) {
              value.forEach((item) => {
                formData.append(`${key}[]`, item);
              });
            } else if (typeof value === "object" && !(value instanceof File)) {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          }
        }

        const loanPurposeValidationMessage =
          this.getLoanPurposeValidationMessage(normalizedUserForm);
        if (loanPurposeValidationMessage) {
          this.$refs.alertBox.showAlert(loanPurposeValidationMessage, "warning");
          return;
        }

        console.log(
          "Submitting loan form with fields:",
          Array.from(formData.keys())
        );

        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/submit_form`,
          {
            method: "POST",
            credentials: "include",
            body: formData,
          }
        );

        const contentType = response.headers.get("Content-Type") || "";

        if (!response.ok) {
          if (contentType.includes("application/json")) {
            const errorPayload = await response.json();
            throw new Error(
              errorPayload.message ||
                errorPayload.error ||
                `Unexpected server error (${response.status})`
            );
          }

          const fallback = await response.text();
          throw new Error(
            `Unexpected error from server or gateway: ${
              response.status
            } - ${fallback.slice(0, 200)}`
          );
        }

        if (!contentType.includes("application/json")) {
          const fallback = await response.text();
          throw new Error(
            `Unexpected error from server or gateway: ${
              response.status
            } - ${fallback.slice(0, 200)}`
          );
        }

        const res = await response.json();
        console.log("Loan submit response:", res);

        if (res.success && res.public_id && res.result) {
          this.$refs.alertBox.showAlert(res.message, "success");
          this.addStep(); // ✅ only happens if real success
        } else {
          throw new Error("Form not accepted. Possibly blocked by server.");
        }
      } catch (error) {
        console.error(error);
        this.$refs.alertBox.showAlert(
          "เกิดข้อผิดพลาด: " + error.message,
          "error"
        );
      } finally {
        this.isSubmitting = false;
      }
    },

    async APIeditForm() {
      if (this.isSubmitting) return; // Prevent if already submitting
      this.isSubmitting = true;
      try {
        const formData = new FormData();
        formData.append("public_id", this.formID); // Include formID
        const fileAliasMap = {
          dadFile: "dad_file",
          momFile: "mom_file",
          fanFile: "fan_file",
          otherFile: "other_file",
          maritalFile: "Marital_status_of_parents_file",
          otherFile_certificate: "other_NonParent_Custody_Certificate_file",
        };
        const normalizedUserForm = {};

        // Log the form data to check if it's populated correctly
        for (const key in this.UserForm) {
          const normalizedKey = fileAliasMap[key] || key;
          const value = this.UserForm[key];

          // Skip empty keys
          if (
            key === "" ||
            value === null ||
            value === undefined ||
            value === ""
          ) {
            continue;
          }

          normalizedUserForm[normalizedKey] = value;

          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              formData.append(`${normalizedKey}[${index}]`, item);
            });
          } else if (typeof value === "object" && !(value instanceof File)) {
            // For objects, stringify the value
            formData.append(normalizedKey, JSON.stringify(value));
          } else {
            // For other values, directly append
            formData.append(normalizedKey, value);
          }
        }

        const loanPurposeValidationMessage =
          this.getLoanPurposeValidationMessage(normalizedUserForm);
        if (loanPurposeValidationMessage) {
          this.$refs.alertBox.showAlert(loanPurposeValidationMessage, "warning");
          return;
        }

        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/edit_form`,
          {
            method: "POST",
            credentials: "include",
            body: formData,
          }
        );

        const contentType = response.headers.get("Content-Type") || "";

        if (response.ok) {
          const res = await response.json();
          this.$refs.alertBox.showAlert(res.message, "success");
          this.addStep();
        } else if (contentType.includes("application/json")) {
          const errorPayload = await response.json();
          throw new Error(
            errorPayload.message ||
              errorPayload.error ||
              `Unexpected server error (${response.status})`
          );
        } else {
          const errorText = await response.text();
          throw new Error(`Error: ${response.status} - ${errorText}`);
        }
      } catch (error) {
        console.error("Error occurred:", error.message);
        this.$refs.alertBox.showAlert(
          "เกิดข้อผิดพลาด: " + error.message,
          "error"
        );
      } finally {
        this.isSubmitting = false;
      }
    },

    // Progress Bar
    scrollToFormTop() {
      const scrollContainer = document.querySelector(".screen-control");
      const scrollTarget = scrollContainer || window;

      setTimeout(() => {
        if (scrollTarget === window) {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          return;
        }

        scrollTarget.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 120);
    },
    addStep() {
      const carousel = document.querySelector("#LoanForm");
      const carouselInstance =
        Carousel.getInstance(carousel) || new Carousel(carousel);
      if (this.step <= 6) {
        const targetElement = document.querySelector(
          `.pgs-step-${this.step + 1}`
        );
        const targetElement2 = document.querySelector(
          `.sl-step-${this.step + 1}`
        );
        targetElement.classList.add("active");
        targetElement2.classList.add("active");
        this.step++;
        carouselInstance.next();
        this.scrollToFormTop();
      }
    },
    deleteStep() {
      if (this.step > 1) {
        const targetElement = document.querySelector(`.pgs-step-${this.step}`);
        const targetElement2 = document.querySelector(`.sl-step-${this.step}`);
        targetElement.classList.remove("active");
        targetElement2.classList.remove("active");
        this.step--;
        this.scrollToFormTop();
      }
    },
    // =======================================================================

    // set next and back button delayed
    disabledButton() {
      this.buttonStatus = true;
      setTimeout(() => {
        this.buttonStatus = false;
      }, 500); // 500ms = 0.5 seconds
    },

    checkFanStatus(event) {
      this.showInput_fan = event.target.value === "มีคู่สมรส";
      this.fan_unknown = event.target.value === "โสด";
    },

    // Make input type number can only type number not the math symbols
    input_number_block_mathsymbol(event) {
      // Block 'e', '+', and '-' keys for type="number" inputs
      if (["e", "E", "+", "-", "."].includes(event.key)) {
        event.preventDefault();
      }
    },

    // Make input type number can only type number not the math symbols
    input_number_block_mathsymbol_gpax(event) {
      // Block 'e', '+', and '-' keys for type="number" inputs
      if (["e", "E", "+", "-"].includes(event.key)) {
        event.preventDefault();
      }
    },

    formatIncome(field) {
      const input = String(this.displayIncome[field] || ""); // ensure it's a string
      const raw = input.replace(/[^\d]/g, ""); // remove all non-digit chars

      // Store raw number as integer
      this.formData[field] = raw ? parseInt(raw, 10) : 0;

      // Format with commas
      this.displayIncome[field] = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatDisplayIncome(value) {
      if (!value) return "0";
      const raw = String(value).replace(/[^\d]/g, "");
      return raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatStep5Income(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }

      const raw = String(value).replace(/[^\d]/g, "");
      if (!raw) {
        return "-";
      }

      return `${raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} บาท`;
    },

    hasStep5SummaryValue(value) {
      if (Array.isArray(value)) return value.length > 0;
      if (value === null || value === undefined) return false;
      const normalized = String(value).trim();
      return normalized !== "" && normalized !== "null" && normalized !== "-";
    },

    buildStep5SummaryName(firstName, lastName) {
      const parts = [firstName, lastName]
        .map((value) => String(value || "").trim())
        .filter(Boolean);
      return parts.length ? parts.join(" ") : "";
    },

    normalizeStep5SummaryArray(value) {
      if (Array.isArray(value)) {
        return value
          .map((item) => String(item || "").trim())
          .filter(Boolean);
      }

      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return [];
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed
              .map((item) => String(item || "").trim())
              .filter(Boolean);
          }
        } catch (_error) {
          return [trimmed];
        }
      }

      return [];
    },

    getLoanPurposeValidationMessage(formData = {}) {
      const loanPurposes = this.normalizeStep5SummaryArray(
        formData.loanPurpose || formData.loan_purposes_options
      );

      if (
        formData.user_loanType !== "ลักษณะที่ 2" ||
        !loanPurposes.includes("ค่าครองชีพ")
      ) {
        return "";
      }

      const toNumber = (value) => {
        const normalized = Number(String(value ?? 0).replace(/,/g, ""));
        return Number.isFinite(normalized) ? normalized : 0;
      };
      const totalIncome =
        toNumber(formData.user_job_income) +
        (formData.fan_status === "มีคู่สมรส"
          ? toNumber(formData.fan_income)
          : 0) +
        toNumber(formData.dad_income) +
        toNumber(formData.mom_income) +
        toNumber(formData.other_income);

      if (totalIncome <= 360000) {
        return "";
      }

      return "ผู้กู้ลักษณะที่ 2 ที่มีรายได้รวมเกิน 360,000 บาท/ปี ไม่สามารถเลือก 'ค่าครองชีพ' ในหัวข้อความประสงค์ขอกู้ยืมได้ กรุณาแก้ไขข้อมูลก่อนบันทึก";
    },

    buildVisibleStep5SummaryItems(items) {
      return items.filter((item) => {
        if (!item) return false;
        if (item.chips) return item.chips.length > 0;
        if (item.lines) return item.lines.length > 0;
        return this.hasStep5SummaryValue(item.value);
      });
    },

    buildStep5SummaryHighlights(formData) {
      const totalPublicService =
        (parseInt(formData.Public_Service_Number_MFU333, 10) || 0) +
        (parseInt(formData.Public_Service_Number_selfCreated, 10) || 0) +
        (parseInt(formData.Public_Service_Number_eLearning, 10) || 0);

      return [
        {
          label: "รหัสนักศึกษา",
          value: formData.user_studentID,
        },
        {
          label: "ประเภทผู้กู้",
          value: formData.user_studentType,
        },
        {
          label: "ชั่วโมงกิจกรรมรวม",
          value: totalPublicService > 0 ? `${totalPublicService} ชั่วโมง` : "",
        },
      ].filter((item) => this.hasStep5SummaryValue(item.value));
    },

    buildStep5SummarySections(formData) {
      const sections = [];
      const totalPublicService =
        (parseInt(formData.Public_Service_Number_MFU333, 10) || 0) +
        (parseInt(formData.Public_Service_Number_selfCreated, 10) || 0) +
        (parseInt(formData.Public_Service_Number_eLearning, 10) || 0);
      const dailyFees = this.normalizeStep5SummaryArray(
        formData.dailyFee || formData.daily_expenses_options
      );
      const loanPurposes = this.normalizeStep5SummaryArray(
        formData.loanPurpose || formData.loan_purposes_options
      );
      const siblingsData = Array.isArray(this.siblings)
        ? this.siblings
        : this.normalizeStep5SummaryArray(formData.siblings);

      const addSection = (title, items, options = {}) => {
        const visibleItems = this.buildVisibleStep5SummaryItems(items);
        if (!visibleItems.length) return;
        sections.push({
          title,
          items: visibleItems,
          fullWidth: Boolean(options.fullWidth),
          description: options.description || "",
        });
      };

      addSection("ข้อมูลผู้กู้ยืม", [
        {
          label: "ชื่อ-นามสกุล",
          value: this.buildStep5SummaryName(
            formData.user_username,
            formData.user_surname
          ),
        },
        {
          label: "อายุ",
          value: this.hasStep5SummaryValue(formData.user_old)
            ? `${formData.user_old} ปี`
            : "",
        },
        {
          label: "เบอร์โทรศัพท์",
          value: formData.user_phoneNumber,
        },
        {
          label: "บัตรประชาชน",
          value: formData.user_citizenID,
        },
      ]);

      addSection("ข้อมูลการศึกษา", [
        {
          label: "ระดับการศึกษา",
          value: formData.user_lvlStudy,
        },
        {
          label: "ภาคเรียน / ปีการศึกษา",
          value:
            formData.user_semesterStudy || formData.user_yearStudy
              ? `ภาคเรียนที่ ${formData.user_semesterStudy || "-"} / ปีการศึกษา ${
                  formData.user_yearStudy || "-"
                }`
              : "",
        },
        {
          label: "สำนักวิชา",
          value: formData.user_faculty,
        },
        {
          label: "สาขาวิชา",
          value: formData.user_fieldStudy,
        },
        {
          label: "รหัสนักศึกษา",
          value: formData.user_studentID,
        },
        {
          label: "GPAX",
          value: formData.user_gpax,
        },
        {
          label: "สถานภาพการเป็นนักศึกษา",
          value: formData.user_studentStatus,
        },
        {
          label: "เหตุผลสถานภาพ",
          value: formData.user_studentStatus_reason,
        },
        {
          label: "ประเภทของผู้กู้ยืม",
          value: formData.user_studentType,
        },
        {
          label: "จบการศึกษาระดับ",
          value: formData.user_graduateLvl,
        },
      ]);

      addSection("ชั่วโมงกิจกรรม", [
        {
          label: "MFU CHARACTER (MFU333)",
          value:
            (parseInt(formData.Public_Service_Number_MFU333, 10) || 0) > 0
              ? `${formData.Public_Service_Number_MFU333} ชั่วโมง`
              : "",
        },
        {
          label: "กิจกรรมสร้างเอง",
          value:
            (parseInt(formData.Public_Service_Number_selfCreated, 10) || 0) > 0
              ? `${formData.Public_Service_Number_selfCreated} ชั่วโมง`
              : "",
        },
        {
          label: "SET e-learning / อื่นๆ",
          value:
            (parseInt(formData.Public_Service_Number_eLearning, 10) || 0) > 0
              ? `${formData.Public_Service_Number_eLearning} ชั่วโมง`
              : "",
        },
        {
          label: "รวม",
          value: totalPublicService > 0 ? `${totalPublicService} ชั่วโมง` : "",
        },
      ]);

      addSection(
        "ข้อมูลการเงินและการกู้ยืม",
        [
          {
            label: "ค่าใช้จ่ายในชีวิตประจำวัน",
            chips: dailyFees,
          },
          {
            label: "อาชีพ",
            value: formData.user_job,
          },
          {
            label: "รายได้จากงาน",
            value:
              Number(formData.user_job_income || 0) > 0
                ? this.formatStep5Income(formData.user_job_income)
                : "",
          },
          {
            label: "ได้รับทุนการศึกษาจาก",
            value: formData.user_scholarship_income,
          },
          {
            label: "ผู้กู้มีบัตรสวัสดิการแห่งรัฐ หรือไม่",
            value:
              formData.user_studentType === "รายใหม่"
                ? formData.has_welfare_card
                : "",
          },
          {
            label: "ผู้กู้เคยรับทุนการศึกษา กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.) หรือไม่",
            value:
              formData.user_studentType === "รายใหม่"
                ? formData.has_eef_scholarship
                : "",
          },
          {
            label: "ความประสงค์ขอกู้ยืม",
            chips: loanPurposes,
          },
          {
            label: "ลักษณะของผู้กู้ยืม",
            value: formData.user_loanType,
          },
        ],
        { fullWidth: true }
      );

      if (this.hasStep5SummaryValue(formData.fan_status)) {
        addSection("ข้อมูลคู่สมรส", [
          {
            label: "สถานะ",
            value: formData.fan_status,
          },
          {
            label: "ชื่อ-นามสกุล",
            value:
              formData.fan_status === "มีคู่สมรส"
                ? this.buildStep5SummaryName(formData.fan_name, formData.fan_surname)
                : "",
          },
          {
            label: "อายุ",
            value:
              formData.fan_status === "มีคู่สมรส" &&
              this.hasStep5SummaryValue(formData.fan_old)
                ? `${formData.fan_old} ปี`
                : "",
          },
          {
            label: "บัตรประชาชน",
            value: formData.fan_status === "มีคู่สมรส" ? formData.fan_citizenID : "",
          },
          {
            label: "เบอร์โทรศัพท์",
            value: formData.fan_status === "มีคู่สมรส" ? formData.fan_phoneNumber : "",
          },
          {
            label: "อีเมล",
            value: formData.fan_status === "มีคู่สมรส" ? formData.fan_email : "",
          },
          {
            label: "อาชีพ",
            value: formData.fan_status === "มีคู่สมรส" ? formData.fan_job : "",
          },
          {
            label: "รายได้ต่อปี",
            value:
              formData.fan_status === "มีคู่สมรส" && Number(formData.fan_income || 0) > 0
                ? this.formatStep5Income(formData.fan_income)
                : "",
          },
        ]);
      }

      if (this.hasStep5SummaryValue(formData.dad_status)) {
        addSection("ข้อมูลบิดา", [
          {
            label: "สถานะ",
            value: formData.dad_status,
          },
          {
            label: "ชื่อ-นามสกุล",
            value: this.buildStep5SummaryName(formData.dad_name, formData.dad_surname),
          },
          {
            label: "อายุ",
            value:
              formData.dad_status === "มีชีวิตอยู่" &&
              this.hasStep5SummaryValue(formData.dad_old)
                ? `${formData.dad_old} ปี`
                : "",
          },
          {
            label: "บัตรประชาชน",
            value: formData.dad_status === "มีชีวิตอยู่" ? formData.dad_citizenID : "",
          },
          {
            label: "เบอร์โทรศัพท์",
            value: formData.dad_status === "มีชีวิตอยู่" ? formData.dad_phoneNumber : "",
          },
          {
            label: "อีเมล",
            value: formData.dad_status === "มีชีวิตอยู่" ? formData.dad_email : "",
          },
          {
            label: "อาชีพ",
            value: formData.dad_status === "มีชีวิตอยู่" ? formData.dad_job : "",
          },
          {
            label: "รายได้ต่อปี",
            value:
              formData.dad_status === "มีชีวิตอยู่" && Number(formData.dad_income || 0) > 0
                ? this.formatStep5Income(formData.dad_income)
                : "",
          },
        ]);
      }

      if (this.hasStep5SummaryValue(formData.mom_status)) {
        addSection("ข้อมูลมารดา", [
          {
            label: "สถานะ",
            value: formData.mom_status,
          },
          {
            label: "ชื่อ-นามสกุล",
            value: this.buildStep5SummaryName(formData.mom_name, formData.mom_surname),
          },
          {
            label: "อายุ",
            value:
              formData.mom_status === "มีชีวิตอยู่" &&
              this.hasStep5SummaryValue(formData.mom_old)
                ? `${formData.mom_old} ปี`
                : "",
          },
          {
            label: "บัตรประชาชน",
            value: formData.mom_status === "มีชีวิตอยู่" ? formData.mom_citizenID : "",
          },
          {
            label: "เบอร์โทรศัพท์",
            value: formData.mom_status === "มีชีวิตอยู่" ? formData.mom_phoneNumber : "",
          },
          {
            label: "อีเมล",
            value: formData.mom_status === "มีชีวิตอยู่" ? formData.mom_email : "",
          },
          {
            label: "อาชีพ",
            value: formData.mom_status === "มีชีวิตอยู่" ? formData.mom_job : "",
          },
          {
            label: "รายได้ต่อปี",
            value:
              formData.mom_status === "มีชีวิตอยู่" && Number(formData.mom_income || 0) > 0
                ? this.formatStep5Income(formData.mom_income)
                : "",
          },
        ]);
      }

      addSection("ข้อมูลครอบครัวและผู้ปกครอง", [
        {
          label: "สถานภาพสมรสของบิดามารดา",
          value: formData.Marital_status_of_parents,
        },
        {
          label: "ผู้แทนโดยชอบธรรม / ผู้ปกครอง",
          value: formData.rightful_guardian,
        },
        {
          label: "ชื่อผู้ปกครอง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา"
              ? this.buildStep5SummaryName(formData.other_name, formData.other_surname)
              : "",
        },
        {
          label: "อายุผู้ปกครอง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา" &&
            this.hasStep5SummaryValue(formData.other_old)
              ? `${formData.other_old} ปี`
              : "",
        },
        {
          label: "ความเกี่ยวข้อง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา"
              ? formData.other_relationship
              : "",
        },
        {
          label: "บัตรประชาชนผู้ปกครอง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา"
              ? formData.other_citizenID
              : "",
        },
        {
          label: "เบอร์โทรศัพท์ผู้ปกครอง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา"
              ? formData.other_phoneNumber
              : "",
        },
        {
          label: "อีเมลผู้ปกครอง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา"
              ? formData.other_email
              : "",
        },
        {
          label: "อาชีพผู้ปกครอง",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา"
              ? formData.other_job
              : "",
        },
        {
          label: "รายได้ผู้ปกครองต่อปี",
          value:
            formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา" &&
            Number(formData.other_income || 0) > 0
              ? this.formatStep5Income(formData.other_income)
              : "",
        },
      ]);

      if (Array.isArray(siblingsData) && siblingsData.length) {
        const siblingLines = siblingsData
          .map((sibling, index) => {
            if (!sibling || typeof sibling !== "object") return "";
            const statusLabel =
              sibling.status === "working"
                ? "ทำงานแล้ว"
                : sibling.status === "studying"
                ? "กำลังศึกษา"
                : "ไม่ระบุ";
            const details = [`พี่น้องคนที่ ${index + 1}`, statusLabel];

            if (sibling.status === "working") {
              if (this.hasStep5SummaryValue(sibling.job)) {
                details.push(`อาชีพ ${sibling.job}`);
              }
              if (Number(sibling.income || 0) > 0) {
                details.push(`รายได้ ${this.formatStep5Income(sibling.income)}`);
              }
            }

            if (
              sibling.status === "studying" &&
              this.hasStep5SummaryValue(sibling.educationLevel)
            ) {
              details.push(`ระดับการศึกษา ${sibling.educationLevel}`);
            }

            return details.join(" • ");
          })
          .filter(Boolean);

        addSection(
          "ข้อมูลพี่น้อง (ไม่รวมผู้กู้ยืม)",
          [
            {
              label: "รายการพี่น้อง",
              lines: siblingLines,
            },
          ],
          { fullWidth: true }
        );
      }

      addSection(
        formData.user_studentType ===
          "ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร"
          ? "เหตุผลที่ไม่สามารถสำเร็จการศึกษาตามหลักสูตร"
          : "คำบรรยายเพิ่มเติม",
        [
          {
            label: "รายละเอียด",
            value: formData.description || this.loanDescription,
          },
        ],
        { fullWidth: true }
      );

      return sections;
    },

    lenght_Validation(event, maxLength) {
      if (event.target.value.length > maxLength) {
        event.target.value = event.target.value.slice(0, maxLength); // Automatically trim the input
      }

      if (event.target.value.length < maxLength) {
        event.target.style.backgroundColor = "#FFFF99"; // Highlight background
      } else {
        event.target.style.backgroundColor = ""; // Reset background
      }
    },

    lenght_Validation_form(inputValue, expectedLength, alertMessage) {
      if (inputValue == "" || !inputValue) return true;
      if (inputValue.length < expectedLength && inputValue !== "") {
        this.$refs.alertBox.showAlert(alertMessage, "warning");
        return false;
      }
      return true;
    },

    input_file_size_limit(event) {
      const file = event.target.files[0]; // Get the first file
      if (file) {
        const maxSize = 10 * 1024 * 1024; // 10MB in bytes
        const maxFilenameLength = 150; // 150 characters

        if (file.size > maxSize) {
          event.target.value = ""; // Reset the file input
          return this.$refs.alertBox.showAlert(
            "ขนาดไฟล์ต้องไม่เกิน 10MB",
            "warning"
          );
        }

        const isPDF =
          file.type === "application/pdf" ||
          file.name.toLowerCase().endsWith(".pdf");
        if (!isPDF) {
          event.target.value = ""; // Reset the file input
          return this.$refs.alertBox.showAlert(
            "อนุญาตเฉพาะไฟล์ PDF เท่านั้น",
            "warning"
          );
        }

        // Check file name length
        if (file.name.length > maxFilenameLength) {
          event.target.value = ""; // Reset the file input
          return this.$refs.alertBox.showAlert(
            "ชื่อไฟล์ของคุณยาวเกินไป",
            "warning"
          );
        }
      }
    },

    input_validation_check() {
      // check the status of step

      const form_step = document.querySelector(`#form_step_${this.step}`);
      const form_step_input = form_step.querySelectorAll(
        "input[required], select[required]"
      );

      // Map element IDs to their values
      // This value is for checking validation if the require is empty or not.
      const form_step_input_value = Object.fromEntries(
        Array.from(form_step_input).map((input) => [
          input.id,
          input.value.trim(),
        ])
      );

      // Add error on input
      Object.entries(form_step_input_value).forEach(([key, value]) => {
        const element = document.getElementById(`${key}`);

        if (value === "" && element) {
          element.classList.add("error");
        }

        if (element) {
          element.addEventListener("input", () => {
            if (element.value.trim() !== "") {
              element.classList.remove("error");
            }
          });
        }
      });
      if (Object.values(form_step_input_value).some((value) => value === "")) {
        return this.$refs.alertBox.showAlert(
          "กรุณากรอกข้อมูลให้ครบถ้วน",
          "warning"
        );
      } else {
        // if input lenght is not correct alert
        if (this.input_reach_lenght == false)
          return this.$refs.alertBox.showAlert(
            "กรุณากรอกข้อมูลของให้ถูกต้อง",
            "warning"
          );
        // Validation for check box in step 2
        switch (this.step) {
          case 1: {
            // GPAX check
            if (
              form_step_input_value.user_gpax < 2.0 &&
              this.user_studentType ===
                "ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร"
            ) {
              return this.$refs.alertBox.showAlert(
                "เกรดของคุณไม่ผ่านสำหรับผู้กู้ยืมเกินปีที่กำหนด",
                "warning"
              );
            } else if (form_step_input_value.user_gpax < 1.8) {
              return this.$refs.alertBox.showAlert(
                "เกรดของคุณไม่ผ่าน",
                "warning"
              );
            } else if (
              form_step_input_value.user_gpax > 4 ||
              form_step_input_value.user_gpax < 0
            ) {
              return this.$refs.alertBox.showAlert(
                "กรุณากรอกเกรดของคุณให้ถูกต้อง",
                "warning"
              );
            }
            if (
              !this.lenght_Validation_form(
                form_step_input_value.user_gpax,
                4,
                "กรุณากรอก GPAX ของคุณให้ถูกต้อง"
              )
            )
              return;
            this.addStep();
            break;
          }
          case 2: {
            // สำหรับ ได้รับค่าใช้จ่ายในชีวิตประจำวัน
            // Get the container element
            const divFee = document.getElementById("div_fee_checkbox");
            // Get all checkboxes inside the container
            const checkboxesFee = divFee.querySelectorAll(
              'input[type="checkbox"]'
            );

            // Check if at least one checkbox is checked
            const isCheckedFee = Array.from(checkboxesFee).some(
              (checkbox) => checkbox.checked
            );

            // If none of the checkboxes are checked, alert the user
            if (!isCheckedFee) {
              divFee.classList.add("error");
              return this.$refs.alertBox.showAlert(
                "กรุณากรอกข้อมูลให้ครบถ้วน",
                "warning"
              );
            }

            // สำหรับ มีความประสงค์จะขอกู้ยืมเพื่อใช้ในการศึกษา
            // Get the container element
            const divLoan = document.getElementById("div_feeused_checkbox");
            // Get all checkboxes inside the container
            const checkboxesLoan = divLoan.querySelectorAll(
              'input[type="checkbox"]'
            );

            // Check if at least one checkbox is checked
            const isCheckedLoan = Array.from(checkboxesLoan).some(
              (checkbox) => checkbox.checked
            );

            // If none of the checkboxes are checked, alert the user
            if (!isCheckedLoan) {
              divLoan.classList.add("error");
              return this.$refs.alertBox.showAlert(
                "กรุณากรอกข้อมูลให้ครบถ้วน",
                "warning"
              );
            }

            if (this.user_studentType === "รายใหม่") {
              // 📝 ตรวจสอบบัตรสวัสดิการแห่งรัฐ
              if (!this.formData.has_welfare_card) {
                return this.$refs.alertBox.showAlert(
                  "กรุณาเลือกว่าผู้กู้มีบัตรสวัสดิการแห่งรัฐ หรือไม่",
                  "warning"
                );
              }

              // 📝 ตรวจสอบไฟล์บัตรสวัสดิการ (ถ้าเลือก "มี")
              if (this.formData.has_welfare_card === "มี") {
                const welfareFileInput = document.getElementById("welfare_card_file");
                if (welfareFileInput && !welfareFileInput.files.length && !this.welfare_card_file_useOld) {
                  return this.$refs.alertBox.showAlert(
                    "กรุณาแนบสำเนาบัตรสวัสดิการแห่งรัฐ",
                    "warning"
                  );
                }
              }

              // 📝 ตรวจสอบทุน กสศ.
              if (!this.formData.has_eef_scholarship) {
                return this.$refs.alertBox.showAlert(
                  "กรุณาเลือกว่า ผู้กู้เคยรับทุนการศึกษา กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.) หรือไม่",
                  "warning"
                );
              }

              // 📝 ตรวจสอบไฟล์ทุน กสศ. (ถ้าเลือก "เคย")
              if (this.formData.has_eef_scholarship === "เคย") {
                const eefFileInput = document.getElementById("eef_scholarship_file");
                if (eefFileInput && !eefFileInput.files.length && !this.eef_scholarship_file_useOld) {
                  return this.$refs.alertBox.showAlert(
                    "กรุณาแนบหลักฐานการรับทุน กสศ.",
                    "warning"
                  );
                }
              }
            }

            // Public service hour check
            if (!this.isPassed) {
              return this.$refs.alertBox.showAlert(
                "ชั่วโมงจิตสาธารณะของคุณไม่ผ่าน",
                "warning"
              );
            }

            if (
              !this.lenght_Validation_form(
                form_step_input_value.user_phoneNumber,
                10,
                "กรุณากรอกหมายเลขโทรศัพท์ของคุณให้ถูกต้อง"
              )
            )
              return;

            if (
              !this.lenght_Validation_form(
                form_step_input_value.user_citizenID,
                13,
                "กรุณากรอกหมายเลขบัตรประชาชนของคุณให้ถูกต้อง"
              )
            )
              return;

            this.addStep();
            break;
          }
          case 3:
            // Phone number validation (at least 10 digits)
            if (
              !this.lenght_Validation_form(
                form_step_input_value.dad_phoneNumber,
                10,
                "กรุณากรอกหมายเลขโทรศัพท์บิดาของคุณให้ถูกต้อง"
              )
            )
              return;
            if (
              !this.lenght_Validation_form(
                form_step_input_value.mom_phoneNumber,
                10,
                "กรุณากรอกหมายเลขโทรศัพท์มารดาของคุณให้ถูกต้อง"
              )
            )
              return;
            if (
              !this.lenght_Validation_form(
                form_step_input_value.other_phoneNumber,
                10,
                "กรุณากรอกหมายเลขโทรศัพท์ผู้ปกครองของคุณให้ถูกต้อง"
              )
            )
              return;

            // Citizen ID validation (at least 13 digits)
            if (this.dad_citizenShip == "ไทย") {
              if (
                !this.lenght_Validation_form(
                  form_step_input_value.dad_citizenID,
                  13,
                  "กรุณากรอกหมายเลขบัตรประชาชนบิดาของคุณให้ถูกต้อง"
                ) &&
                this.dad_citizenShip !== "ต่างชาติ"
              )
                return;
            }
            if (this.mom_citizenShip == "ไทย") {
              if (
                !this.lenght_Validation_form(
                  form_step_input_value.mom_citizenID,
                  13,
                  "กรุณากรอกหมายเลขบัตรประชาชนมารดาของคุณให้ถูกต้อง"
                )
              )
                return;
            }
            if (this.other_citizenShip == "ไทย") {
              if (
                !this.lenght_Validation_form(
                  form_step_input_value.other_citizenID,
                  13,
                  "กรุณากรอกหมายเลขบัตรประชาชนผู้ปกครองของคุณให้ถูกต้อง"
                ) &&
                this.other_citizenShip !== "ต่างชาติ"
              )
                return;
            }
            this.addStep();
            break;
          case 4: {
            if (!this.loanDescription || this.loanDescription.trim() === "") {
              return this.$refs.alertBox.showAlert(
                "กรุณากรอกเหตุผลในการขอกู้ยืมเงิน",
                "warning"
              );
            }
            this.addStep();
            this.$nextTick(() => {
              this.step_5_show_data();
            });
            break;
          }
          case 5:
            break;
        }
      }
    },

    validateNoLeadingZeros(event) {
      const input = event.target;

      // Remove leading zeros dynamically
      if (input.value.length > 0 && input.value.startsWith("0")) {
        input.value = input.value.replace(/^0+/, "");
      }

      // Ensure the input length does not exceed 4 digits
      if (input.value.length > 4) {
        input.value = input.value.slice(0, 4);
      }
    },

    // Remove error when change
    removeError(event) {
      const parentDiv = event.target.closest("div.mb-4");
      if (parentDiv) {
        parentDiv.classList.remove("error");
      }
    },

    step_5_show_data() {
      const formData = {
        ...(this.UserForm && typeof this.UserForm === "object" ? this.UserForm : {}),
      };
      this.show_fan_info = false;
      this.show_other_info = false;

      const removeComma = (val) => {
        if (!val) return 0;
        return Number(String(val).replace(/,/g, ""));
      };
      const normalizeToArray = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim() !== "") {
          return value.split(",").map((item) => item.trim()).filter(Boolean);
        }
        return [];
      };

      document
        .querySelectorAll(
          "#LoanForm input, #LoanForm select, #LoanForm textarea"
        )
        .forEach((field) => {
          if (field.type === "checkbox") {
            if (!formData[field.name]) {
              formData[field.name] = [];
            }
            if (field.checked) {
              formData[field.name].push(field.value);
            }
          } else if (field.type === "file") {
            const normalizedFileField =
              {
                dadFile: "dad_file",
                momFile: "mom_file",
                fanFile: "fan_file",
                otherFile: "other_file",
                maritalFile: "Marital_status_of_parents_file",
                otherFile_certificate:
                  "other_NonParent_Custody_Certificate_file",
              }[field.id] || field.id;
            if (field.files && field.files.length > 0) {
              formData[normalizedFileField] = field.files[0];
            } else {
              formData[normalizedFileField] = null;
            }
          } else if (field.id) {
            if (
              [
                "user_job_income",
                "fan_income",
                "dad_income",
                "mom_income",
                "other_income",
              ].includes(field.id)
            ) {
              formData[field.id] = removeComma(field.value);
            } else {
              formData[field.id] = field.value;
            }
          }
        });

      const fileFlags = [
        {
          flag: this.user_gpax_file,
          file: this.user_gpax_file,
          name: "user_gpax_file",
        },
        {
          flag: this.user_transcript_file_useOld,
          file: this.user_transcript_file,
          name: "user_transcript_file",
        },
        {
          flag: this.user_studentCertificate_file_useOld,
          file: this.user_studentCertificate_file,
          name: "user_studentCertificate_file",
        },
        {
          flag: this.user_courseCertificate_file_useOld,
          file: this.user_courseCertificate_file,
          name: "user_courseCertificate_file",
        },
        { flag: this.fanFile_useOld, file: this.fanFile, name: "fan_file" },
        {
          flag: this.fan_income_file_useOld,
          file: this.fan_income_file,
          name: "fan_income_file",
        },
        { flag: this.dadFile_useOld, file: this.dadFile, name: "dad_file" },
        { flag: this.momFile_useOld, file: this.momFile, name: "mom_file" },
        {
          flag: this.otherFile_useOld,
          file: this.otherFile,
          name: "other_file",
        },
        {
          flag: this.Public_Service_MFU333_File_useOld,
          file: this.Public_Service_MFU333_File,
          name: "Public_Service_MFU333_File",
        },
        {
          flag: this.Public_Service_selfCreated_File_useOld,
          file: this.Public_Service_selfCreated_File,
          name: "Public_Service_selfCreated_File",
        },
        {
          flag: this.Public_Service_eLearning_File_useOld,
          file: this.Public_Service_eLearning_File,
          name: "Public_Service_eLearning_File",
        },
        {
          flag: this.income_file_useOld,
          file: this.income_file,
          name: "income_file",
        },
        {
          flag: this.maritalFile_useOld,
          file: this.maritalFile,
          name: "Marital_status_of_parents_file",
        },
        {
          flag: this.otherFile_certificate_useOld,
          file: this.otherFile_certificate,
          name: "other_NonParent_Custody_Certificate_file",
        },
        {
          flag: this.fan_income_file_useOld,
          file: this.fan_income_file,
          name: "fan_income_file",
        },
        {
          flag: this.dad_family_status_certificate_file_useOld,
          file: this.dad_family_status_certificate_file,
          name: "dad_family_status_certificate_file",
        },
        {
          flag: this.dad_death_certificate_file_useOld,
          file: this.dad_death_certificate_file,
          name: "dad_death_certificate_file",
        },
        {
          flag: this.mom_death_certificate_file_useOld,
          file: this.mom_death_certificate_file,
          name: "mom_death_certificate_file",
        },
        {
          flag: this.dad_family_status_certificate_file_useOld,
          file: this.dad_family_status_certificate_file,
          name: "dad_family_status_certificate_file",
        },
        {
          flag: this.mom_family_status_certificate_file_useOld,
          file: this.mom_family_status_certificate_file,
          name: "mom_family_status_certificate_file",
        },
        {
          flag: this.user_imageFile_useOld,
          file: this.user_imageFile,
          name: "user_imageFile",
        },
        {
          flag: this.user_citizenID_file_useOld,
          file: this.user_citizenID_file,
          name: "user_citizenID_file",
        },
        {
          flag: this.fan_citizenID_file_useOld,
          file: this.fan_citizenID_file,
          name: "fan_citizenID_file",
        },
        {
          flag: this.dad_citizenID_file_useOld,
          file: this.dad_citizenID_file,
          name: "dad_citizenID_file",
        },
        {
          flag: this.mom_citizenID_file_useOld,
          file: this.mom_citizenID_file,
          name: "mom_citizenID_file",
        },
        {
          flag: this.other_citizenID_file_useOld,
          file: this.other_citizenID_file,
          name: "other_citizenID_file",
        },
        {
          flag: this.welfare_card_file_useOld,
          file: this.welfare_card_file,
          name: "welfare_card_file",
        },
        {
          flag: this.eef_scholarship_file_useOld,
          file: this.eef_scholarship_file,
          name: "eef_scholarship_file",
        },
      ];

      applyOldFileFields(formData, fileFlags);

      formData.user_lvlStudy =
        formData.user_lvlStudy || this.UserForm.user_lvlStudy || this.user_lvlStudy;
      formData.user_yearStudy =
        formData.user_yearStudy || this.UserForm.user_yearStudy || this.studyYear;
      formData.user_semesterStudy =
        formData.user_semesterStudy ||
        this.UserForm.user_semesterStudy ||
        this.studySemester;
      formData.user_studentType =
        formData.user_studentType ||
        this.UserForm.user_studentType ||
        this.user_studentType;
      formData.user_studentStatus =
        formData.user_studentStatus ||
        this.UserForm.user_studentStatus ||
        this.user_studentStatus;
      formData.user_faculty =
        formData.user_faculty || this.UserForm.user_faculty || "-";
      formData.user_fieldStudy =
        formData.user_fieldStudy || this.UserForm.user_fieldStudy || "-";

      // 📝 เพิ่มข้อมูลบัตรสวัสดิการและทุน กสศ. เฉพาะผู้กู้รายใหม่
      formData.has_welfare_card =
        formData.user_studentType === "รายใหม่"
          ? this.formData.has_welfare_card || formData.has_welfare_card || ""
          : "";
      formData.has_eef_scholarship =
        formData.user_studentType === "รายใหม่"
          ? this.formData.has_eef_scholarship || formData.has_eef_scholarship || ""
          : "";

      // 📝 เพิ่มไฟล์จริง (File objects) สำหรับการส่ง
      if (this.user_gpax_file instanceof File) {
        formData.user_gpax_file = this.user_gpax_file;
      }
      if (this.user_imageFile instanceof File) {
        formData.user_imageFile = this.user_imageFile;
      }
      if (this.user_citizenID_file instanceof File) {
        formData.user_citizenID_file = this.user_citizenID_file;
      }
      if (this.Public_Service_MFU333_File instanceof File) {
        formData.Public_Service_MFU333_File = this.Public_Service_MFU333_File;
      }
      if (this.welfare_card_file instanceof File) {
        formData.welfare_card_file = this.welfare_card_file;
      }
      if (this.eef_scholarship_file instanceof File) {
        formData.eef_scholarship_file = this.eef_scholarship_file;
      }
      if (this.dad_citizenID_file instanceof File) {
        formData.dad_citizenID_file = this.dad_citizenID_file;
      }
      if (this.dadFile instanceof File) {
        formData.dad_file = this.dadFile;
      }
      if (this.mom_citizenID_file instanceof File) {
        formData.mom_citizenID_file = this.mom_citizenID_file;
      }
      if (this.momFile instanceof File) {
        formData.mom_file = this.momFile;
      }
      if (this.fanFile instanceof File) {
        formData.fan_file = this.fanFile;
      }
      if (this.otherFile instanceof File) {
        formData.other_file = this.otherFile;
      }
      if (this.maritalFile instanceof File) {
        formData.Marital_status_of_parents_file = this.maritalFile;
      }
      if (this.otherFile_certificate instanceof File) {
        formData.other_NonParent_Custody_Certificate_file =
          this.otherFile_certificate;
      }

      this.UserForm = {
        ...this.UserForm,
        ...formData,
      };
      this.UserForm.siblings = JSON.stringify(this.siblings);
      this.UserForm.description = this.loanDescription || formData.description || "";
      this.step5SummaryHighlights = this.buildStep5SummaryHighlights({
        ...formData,
        description: this.UserForm.description,
      });
      this.step5SummarySections = this.buildStep5SummarySections({
        ...formData,
        description: this.UserForm.description,
      });

      // Helper function to update text content
      const setText = (id, text) => {
        const element = document.getElementById(id);
        if (element) element.innerText = text;
      };
      const toggleElement = (id, show) => {
        const element = document.getElementById(id);
        if (element) element.style.display = show ? "" : "none";
      };

      // User info
      setText(
        "step5_user_fullname",
        `${formData.user_username} ${formData.user_surname}`
      );
      setText("step5_user_old", formData.user_old);
      setText("step5_user_phoneNumber", formData.user_phoneNumber);
      setText("step5_user_citizenID", formData.user_citizenID);

      // Study info
      const studyFields = [
        "user_lvlStudy",
        "user_yearStudy",
        "user_semesterStudy",
        "user_studentStatus",
        "user_studentType",
        "user_faculty",
        "user_fieldStudy",
        "user_studentID",
        "user_gpax",
        "user_graduateLvl",
        "Public_Service_Number_MFU333",
        "Public_Service_Number_selfCreated",
        "Public_Service_Number_eLearning",
      ];
      studyFields.forEach((field) =>
        setText(`step5_${field}`, formData[field])
      );

      // User financial info
      ["user_loanType"].forEach((field) => {
        setText(`step5_${field}`, formData[field]);
      });

      const selectedDailyFees = normalizeToArray(formData.dailyFee);
      document.querySelectorAll("#step5_dailyFee > div").forEach((wrapper) => {
        wrapper.style.display = selectedDailyFees.includes(wrapper.dataset.value)
          ? ""
          : "none";
      });

      const selectedLoanPurposes = normalizeToArray(formData.loanPurpose);
      document
        .querySelectorAll("#step5_loanPurpose > div")
        .forEach((wrapper) => {
          wrapper.style.display = selectedLoanPurposes.includes(
            wrapper.dataset.value
          )
            ? ""
            : "none";
        });

      const hasJobExpense = selectedDailyFees.includes("จากการประกอบอาชีพ");
      toggleElement("step5_job_block", hasJobExpense);
      if (hasJobExpense) {
        const userJob = String(formData.user_job || "").trim();
        const userJobIncome = Number(formData.user_job_income || 0);
        toggleElement("step5_user_job_row", userJob !== "");
        toggleElement("step5_user_job_income_row", userJobIncome > 0);
        setText("step5_user_job", formData.user_job);
        setText(
          "step5_user_job_income",
          this.formatStep5Income(formData.user_job_income)
        );
      }

      const hasScholarship = selectedDailyFees.includes("ทุนการศึกษา");
      toggleElement("step5_scholarship_block", hasScholarship);
      if (hasScholarship) {
        const scholarshipValue = String(formData.user_scholarship_income || "").trim();
        toggleElement(
          "step5_user_scholarship_income_row",
          scholarshipValue !== ""
        );
        setText(
          "step5_user_scholarship_income",
          `${formData.user_scholarship_income ?? "-"}`
        );
      }

      // 📝 แสดงข้อมูลบัตรสวัสดิการ/ทุน กสศ. เฉพาะผู้กู้รายใหม่
      const welfareValue =
        formData.user_studentType === "รายใหม่"
          ? formData.has_welfare_card || ""
          : "";
      setText(
        "step5_has_welfare_card",
        welfareValue
      );
      toggleElement("step5_has_welfare_card_row", welfareValue !== "");

      const eefValue =
        formData.user_studentType === "รายใหม่"
          ? formData.has_eef_scholarship || ""
          : "";
      setText(
        "step5_has_eef_scholarship",
        eefValue
      );
      toggleElement("step5_has_eef_scholarship_row", eefValue !== "");

      setText("step5_fan_status", formData.fan_status || "-");

      setText(
        "step5_fan_fullname",
        `${formData.fan_name ? formData.fan_name : "-"} ${
          formData.fan_surname ? formData.fan_surname : "-"
        }`
      );
      if (formData.fan_status === "มีคู่สมรส") {
        this.show_fan_info = true;
        [
          "fan_citizenID",
          "fan_old",
          "fan_phoneNumber",
          "fan_email",
          "fan_job",
        ].forEach((field) => {
          setText(`step5_${field}`, formData[field]);
        });
        setText("step5_fan_income", this.formatStep5Income(formData.fan_income));
      }

      // Dad info
      setText("step5_dad_status", formData.dad_status || "-");

      const dadFullname = `${formData.dad_name ? formData.dad_name : "-"} ${
        formData.dad_surname ? formData.dad_surname : "-"
      }`;
      setText("step5_dad_fullname_deceased", dadFullname);
      setText("step5_dad_fullname_alive", dadFullname);
      if (formData.dad_status === "มีชีวิตอยู่") {
        [
          "dad_citizenID",
          "dad_old",
          "dad_phoneNumber",
          "dad_email",
          "dad_job",
        ].forEach((field) => {
          setText(`step5_${field}`, formData[field]);
        });
        setText("step5_dad_income", this.formatStep5Income(formData.dad_income));
      }

      // Mom info
      setText("step5_mom_status", formData.mom_status || "-");

      const momFullname = `${formData.mom_name ? formData.mom_name : "-"} ${
        formData.mom_surname ? formData.mom_surname : "-"
      }`;
      setText("step5_mom_fullname_deceased", momFullname);
      setText("step5_mom_fullname_alive", momFullname);
      if (formData.mom_status === "มีชีวิตอยู่") {
        [
          "mom_citizenID",
          "mom_old",
          "mom_phoneNumber",
          "mom_email",
          "mom_job",
        ].forEach((field) => {
          setText(`step5_${field}`, formData[field]);
        });
        setText("step5_mom_income", this.formatStep5Income(formData.mom_income));
      }

      // Parent's marital status
      setText("step5_mariage_status", formData.Marital_status_of_parents);

      setText(
        "step5_other_fullname",
        `${formData.other_name ? formData.other_name : "-"} ${
          formData.other_surname ? formData.other_surname : "-"
        }`
      );
      // Rightful guardian
      setText("step5_rightful_guardian", formData.rightful_guardian);
      if (formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา") {
        this.show_other_info = true;
        [
          "other_citizenID",
          "other_old",
          "other_phoneNumber",
          "other_email",
          "other_job",
          "other_relationship",
        ].forEach((field) => {
          setText(`step5_${field}`, formData[field]);
        });
        setText(
          "step5_other_income",
          this.formatStep5Income(formData.other_income)
        );
      }
      // เพิ่มเติม: แสดง description ใน step 5
      setText(
        "step5_description",
        formData.description || this.loanDescription || "-"
      );
    },

    // Static data
    async getEdu_lvl() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/get/education_level`
        );
        if (response.ok) {
          const staticData = await response.json();
          this.educationLevelOptions = staticData
            .map((item) => item.level)
            .filter(Boolean);
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getFaculty() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/get/faculty`
        );
        if (response.ok) {
          const staticData = await response.json();
          this.setStaticData("user_faculty", staticData, "Faculty");
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getStudyField(value) {
      try {
        const response = await fetch(
          `${
            process.env.VUE_APP_API_BASE_URL
          }/user/loan/get/fieldofstudy?faculty=${encodeURIComponent(value)}`
        );

        if (response.ok) {
          let staticData = await response.json();

          // Remove "มหาบัณฑิต" courses if the study level is ปริญญาตรี
          if (this.user_lvlStudy === "ปริญญาตรี") {
            staticData = staticData.filter(
              (item) => !item.Field_of_study.includes("มหาบัณฑิต"),
              (item) => !item.Field_of_study.includes("ประกาศนียบัตร")
            );
          }

          if (this.user_lvlStudy === "ปริญญาโท") {
            staticData = staticData.filter((item) =>
              item.Field_of_study.includes("มหาบัณฑิต")
            );
          }

          if (this.user_lvlStudy === "ประกาศนียบัตร") {
            staticData = staticData.filter((item) =>
              item.Field_of_study.includes("ประกาศนียบัตร")
            );
          }

          this.setStaticData("user_fieldStudy", staticData, "Field_of_study");
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getGraduatedLevel() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/get/graduatedLevel`
        );
        if (response.ok) {
          const staticData = await response.json();
          const educationOrder = {
            "มัธยมศึกษาตอนปลาย": 1,
            "ปวช./ปวส./ปวท.": 2,
            อนุปริญญาตรี: 3,
            ประกาศนียบัตร: 4,
            ปริญญาตรี: 5,
          };

          this.graduatedLevelOptions = staticData
            .map((item) => item.Graduated_level)
            .filter(Boolean)
            .sort((a, b) => {
              const rankA = educationOrder[a] ?? Number.MAX_SAFE_INTEGER;
              const rankB = educationOrder[b] ?? Number.MAX_SAFE_INTEGER;
              if (rankA !== rankB) return rankA - rankB;
              return a.localeCompare(b, "th");
            });
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getDailyExpensesOptions() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/get/dailyExpensesOptions`
        );
        if (response.ok) {
          const staticData = await response.json();
          const filteredData = staticData.filter(
            (item) => String(item.category || "").trim() !== "ทุนการศึกษา"
          );

          this.setStaticDataCheckBox(
            "user_DailyExpenses",
            filteredData,
            "category",
            "dailyFee"
          );
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getLoanPurposesOptions() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/get/loanPurposesOption`
        );
        if (response.ok) {
          const staticData = await response.json();
          this.setStaticDataCheckBox(
            "user_feeused",
            staticData,
            "purpose",
            "loanPurpose"
          );
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getServerStatus() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/server/status`
        );
        if (response.ok) {
          const serverStatus = await response.json();
          this.studyYear = serverStatus.study_year;
          this.studySemester = serverStatus.study_semester;
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getServerStatus_kickUser() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/server/status`
        );
        if (response.ok) {
          const serverStatus = await response.json();
          if (serverStatus.server_status === "close") {
            Swal.fire({
              text: "ระบบการยื่นกู้ยังไม่เปิด ณ ขณะนี้",
              icon: "error",
              confirmButtonColor: "#964040",
            });
            return this.$router.replace("/user");
          }
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getServerStatus_editLoan() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/server/editLoan/status`
        );
        if (response.ok) {
          const serverStatus = await response.json();
          if (serverStatus.server_status === "close") {
            Swal.fire({
              text: "ระบบการแก้ไขคำขอกู้ยังไม่เปิด ณ ขณะนี้",
              icon: "error",
              confirmButtonColor: "#964040",
            });
            return this.$router.replace("/user");
          }

          if (
            String(this.studyYear) !== String(serverStatus.study_year) ||
            String(this.studySemester) !== String(serverStatus.study_semester)
          ) {
            Swal.fire({
              text: "คุณไม่สามารถแก้ไขคำขอกู้ได้ในปีการศึกษาหรือภาคเรียนอื่น",
              icon: "error",
              confirmButtonColor: "#964040",
            });
            return this.$router.replace("/user");
          }
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getStudentLoanLast() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/get/loan/last`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        if (response.ok) {
          const staticData = await response.json();

          if (!staticData) return;

          const sameSemesterYear =
            Number(this.studySemester) ===
              Number(staticData.user_semesterStudy) &&
            Number(this.studyYear) === Number(staticData.user_yearStudy);

          if (!sameSemesterYear) return;

          const statusMap = {
            อยู่ระหว่างดำเนินการ: {
              title: "คุณได้ทำการยื่นคำขอกู้ยืมแล้ว",
              icon: "info",
            },
            ตีกลับเพื่อแก้เอกสาร: {
              title: "กรุณาแก้ไขคำขอกู้ยืมของคุณ",
              icon: "info",
            },
            อนุมัติ: {
              title: "คำขอกู้ยืมของคุณได้รับการอนุมัติ",
              icon: "success",
            },
            ผ่านการตรวจสอบคุณสมบัติ: {
              title: "คำขอกู้ยืมของคุณผ่านการตรวจสอบคุณสมบัติ",
              icon: "success",
            },
            ไม่อนุมัติ: {
              title: "คำขอกู้ยืมของคุณไม่อนุมัติ",
              icon: "error",
            },
            อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม: {
              title: "อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม",
              icon: "info",
            },
            "รอผลการพิจารณาจากกองทุน กยศ.": {
              title: "คำขอกู้ยืมของคุณอยู่รอผลการพิจารณาจากกองทุน กยศ.",
              icon: "info",
            },
          };

          const statusData = statusMap[staticData.loan_status];
          if (statusData) {
            await Swal.fire({
              title: statusData.title,
              text: "",
              icon: statusData.icon,
              confirmButtonText: "ยืนยัน",
              confirmButtonColor: "#964040",
            });
            return this.$router.replace("/user");
          }
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    setStaticData(element_name, data, detail) {
      let datas = '<option disabled selected value="">กรุณาเลือก</option>';
      data.forEach((uld) => {
        datas += `<option value="${uld[detail]}">${uld[detail]}</option>`;
      });
      // Find the select element by its name or ID
      const element = document.getElementById(element_name);
      if (element) {
        element.innerHTML = datas;
      } else {
        console.error(`Element with selector "${element_name}" not found.`);
      }
    },

    setStaticDataCheckBox(element_name, data, detail, name) {
      let datas = [];
      let step5_checkbox = [];
      data.forEach((uld) => {
        datas += `<div><input class="me-2 form-check-input" type="checkbox" name="${name}" value="${uld[detail]}" id="${uld[detail]}" required/><label for="${uld[detail]}">${uld[detail]}</label></div>`;
        step5_checkbox += `<div class="mb-1" data-value="${uld[detail]}">${uld[detail]}</div>`;
      });

      // Find the select element by its name or ID
      const element = document.getElementById(element_name);
      const step5_element = document.getElementById(`step5_${name}`);
      if (element) {
        element.innerHTML = datas;
      } else {
        console.error(`Element with selector "${element_name}" not found.`);
      }

      if (step5_element) {
        step5_element.innerHTML = step5_checkbox;
      } else {
        console.error(`Element with selector "${step5_element}" not found.`);
      }
    },

    async confirmBoxForm() {
      if (this.isSubmitting) return;
      console.log("confirmBoxForm triggered", {
        step: this.step,
        formID: this.formID,
        isMockMode: this.isMockMode,
      });

      if (this.isMockMode && !this.formID) {
        console.log("Skipping confirmation modal in mock mode");
        this.APIsentForm();
        return;
      }

      if (this.formID) {
        const result = await Swal.fire({
          title: "คุณแน่ใจที่จะแก้ไขข้อมูลหรือไม่",
          showCancelButton: true,
          cancelButtonText: "ยกเลิก",
          confirmButtonText: "ยืนยัน",
          confirmButtonColor: "#964040",
        });

        if (result.isConfirmed) {
          this.APIeditForm();
        }
        return;
      }

      const result = await Swal.fire({
        title: "คุณแน่ใจหรือไม่",
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#964040",
      });

      if (result.isConfirmed) {
        this.APIsentForm();
      }
    },

    // Edit Form
    async getLoanData(value) {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${
            process.env.VUE_APP_API_BASE_URL
          }/user/get/loan/data?id=${encodeURIComponent(value)}`,
          {
            method: "GET",
            credentials: "include", // Ensure cookies are included
          }
        );
        if (response.ok) {
          const staticData = await response.json();
          await this.$nextTick();
          this.setValueFormEdit(staticData);
          return staticData;
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          this.$router.replace("/user");
          throw new Error(errorMessage);
        } else {
          this.$router.replace("/user");
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    setValueFormEdit(data) {
      // Set show file
      const fileMappings = {
        user_gpax_file: "user_gpax_file",
        user_transcript_file: "user_transcript_file",
        user_studentCertificate_file: "user_studentCertificate_file",
        user_courseCertificate_file: "user_courseCertificate_file",
        user_citizenID_file: "user_citizenID_file",
        Public_Service_MFU333_File: "Public_Service_MFU333_File",
        Public_Service_selfCreated_File: "Public_Service_selfCreated_File",
        Public_Service_eLearning_File: "Public_Service_eLearning_File",
        fan_citizenID_file: "fan_citizenID_file",
        fan_income_file: "fan_income_file",
        fan_file: "fanFile",
        dad_file: "dadFile",
        dad_citizenID_file: "dad_citizenID_file",
        mom_file: "momFile",
        mom_citizenID_file: "mom_citizenID_file",
        other_file: "otherFile",
        other_citizenID_file: "other_citizenID_file",
        other_NonParent_Custody_Certificate_file: "otherFile_certificate",
        Marital_status_of_parents_file: "maritalFile",
        dad_death_certificate_file: "dad_death_certificate_file",
        mom_death_certificate_file: "mom_death_certificate_file",
        dad_family_status_certificate_file:
          "dad_family_status_certificate_file",
        mom_family_status_certificate_file:
          "mom_family_status_certificate_file",
        user_imageFile: "user_imageFile",
        income_file: "income_file",
        welfare_card_file: "welfare_card_file",
        eef_scholarship_file: "eef_scholarship_file",
      };

      Object.keys(fileMappings).forEach((key) => {
        if (data[key]) {
          this[key] = true;
          this[fileMappings[key]] = data[key];
        }
      });

      const setValue = (id, Value) => {
        const element = document.getElementById(id);
        if (element) element.value = Value;
      };
      this.user_lvlStudy = data.user_lvlStudy;
      this.user_studentStatus = data.user_studentStatus;
      this.user_studentType = data.user_studentType;
      this.formData.has_welfare_card = data.has_welfare_card || "";
      this.formData.has_eef_scholarship = data.has_eef_scholarship || "";
      const Step1 = [
        "user_lvlStudy",
        "user_faculty",
        "user_loanType",
        "user_gpax",
        "user_studentStatus_reason",
      ];

      this.updateNeededHours();

      const fieldStudyElement = document.getElementById("user_fieldStudy");
      if (fieldStudyElement) {
        fieldStudyElement.innerHTML = `<option value="${data.user_fieldStudy}" selected>${data.user_fieldStudy}</option>`;
      }

      this.$nextTick(() => {
        Step1.forEach((field) => setValue(field, data[field]));
      });

      this.studyYear = data.user_yearStudy;
      this.studySemester = data.user_semesterStudy;
      this.formData.Public_Service_Number_MFU333 =
        data.Public_Service_Number_MFU333;
      this.formData.Public_Service_Number_selfCreated =
        data.Public_Service_Number_selfCreated;
      this.formData.Public_Service_Number_eLearning =
        data.Public_Service_Number_eLearning;

      const Step2 = [
        "user_username",
        "user_surname",
        "user_old",
        "user_phoneNumber",
        "user_citizenID",
        "user_graduateLvl",
      ];

      Step2.forEach((field) => setValue(field, data[field]));

      document
        .querySelectorAll('input[name="dailyFee"]')
        .forEach((checkbox) => {
          if (
            JSON.parse(data.daily_expenses_options).includes(checkbox.value)
          ) {
            checkbox.checked = true;
          }
        });

      if (
        JSON.parse(data.daily_expenses_options).includes("จากการประกอบอาชีพ")
      ) {
        this.finance_income_checkbox = true;

        this.$nextTick(() => {
          this.formData.user_job = data.user_job;
          this.displayIncome.user_job_income = this.formatDisplayIncome(
            data.user_job_income
          );
          this.formData.user_job_income = data.user_job_income;
        });
      }
      if (JSON.parse(data.daily_expenses_options).includes("ทุนการศึกษา")) {
        this.scholarship_income_checkbox = true;

        this.$nextTick(() => {
          this.user_scholarship_income = data.user_scholarship_income;
        });
      }
      let selectedLoanPurposes = [];
      try {
        selectedLoanPurposes = JSON.parse(data.loan_purposes_options || "[]");
      } catch (_error) {
        selectedLoanPurposes = [];
      }

      document
        .querySelectorAll('input[name="loanPurpose"]')
        .forEach((checkbox) => {
          if (selectedLoanPurposes.includes(checkbox.value)) {
            checkbox.checked = true;
          }
        });

      setValue("fan_status", data.fan_status);
      this.$nextTick(() => {
        const fanSelect = document.getElementById("fan_status");
        if (fanSelect) {
          const event = new Event("change", { bubbles: true });
          fanSelect.dispatchEvent(event);
        }
      });

      if (data.fan_status == "มีคู่สมรส") {
        this.showInput_fan = true;
        this.$nextTick(() => {
          setValue("fan_citizenID", data.fan_citizenID);
          setValue("fan_old", data.fan_old);
          setValue("fan_name", data.fan_name);
          setValue("fan_surname", data.fan_surname);
          setValue("fan_phoneNumber", data.fan_phoneNumber);
          setValue("fan_email", data.fan_email);
          setValue("fan_job", data.fan_job);
          this.displayIncome.fan_income = this.formatDisplayIncome(
            data.fan_income
          );
          this.formData.fan_income = data.fan_income;
        });
      }

      if (data.siblings) {
        const parsedSiblings = JSON.parse(data.siblings);
        this.siblings = parsedSiblings;
        this.siblingsCount = parsedSiblings.length;

        // เพิ่มส่วนนี้
        this.$nextTick(() => {
          const siblingsCountInput = document.getElementById("siblings_count");
          if (siblingsCountInput) {
            siblingsCountInput.value = this.siblingsCount;
          }
        });
      } else {
        this.siblings = [];
        this.siblingsCount = 0;

        // เพิ่มส่วนนี้
        this.$nextTick(() => {
          const siblingsCountInput = document.getElementById("siblings_count");
          if (siblingsCountInput) {
            siblingsCountInput.value = 0;
          }
        });
      }

      setValue("dad_status", data.dad_status);
      this.$nextTick(() => {
        const fanSelect = document.getElementById("dad_status");
        if (fanSelect) {
          const event = new Event("change", { bubbles: true });
          fanSelect.dispatchEvent(event);
        }
      });

      this.dad_status = data.dad_status;
      if (data.dad_status == "เสียชีวิต") {
        this.$nextTick(() => {
          setValue("dad_name", data.dad_name);
          setValue("dad_surname", data.dad_surname);
        });
      }

      if (data.dad_status == "มีชีวิตอยู่") {
        this.$nextTick(() => {
          setValue("dad_citizenID", data.dad_citizenID);
          setValue("dad_old", data.dad_old);
          setValue("dad_name", data.dad_name);
          setValue("dad_surname", data.dad_surname);
          setValue("dad_phoneNumber", data.dad_phoneNumber);
          setValue("dad_email", data.dad_email);
          setValue("dad_job", data.dad_job);
          this.displayIncome.dad_income = this.formatDisplayIncome(
            data.dad_income
          );
          this.formData.dad_income = data.dad_income;
        });
      }

      this.mom_status = data.mom_status;
      if (data.mom_status == "เสียชีวิต") {
        this.$nextTick(() => {
          setValue("mom_name", data.mom_name);
          setValue("mom_surname", data.mom_surname);
        });
      }

      if (data.mom_status == "มีชีวิตอยู่") {
        this.$nextTick(() => {
          setValue("mom_citizenID", data.mom_citizenID);
          setValue("mom_old", data.mom_old);
          setValue("mom_name", data.mom_name);
          setValue("mom_surname", data.mom_surname);
          setValue("mom_phoneNumber", data.mom_phoneNumber);
          setValue("mom_email", data.mom_email);
          setValue("mom_job", data.mom_job);
          this.displayIncome.mom_income = this.formatDisplayIncome(
            data.mom_income
          );
          this.formData.mom_income = data.mom_income;
        });
      }

      this.Marital_status_of_parents = data.Marital_status_of_parents;
      this.$nextTick(() => {
        this.Marital_status_of_parents = data.Marital_status_of_parents;
      });

      this.selectedGuardian = data.rightful_guardian;

      if (data.rightful_guardian == "ผู้ปกครองไม่ใช่บิดา มารดา") {
        this.showInput_other = true;
        this.$nextTick(() => {
          setValue("other_citizenID", data.other_citizenID);
          setValue("other_old", data.other_old);
          setValue("other_name", data.other_name);
          setValue("other_surname", data.other_surname);
          setValue("other_phoneNumber", data.other_phoneNumber);
          setValue("other_email", data.other_email);
          setValue("other_job", data.other_job);
          this.displayIncome.other_income = this.formatDisplayIncome(
            data.other_income
          );
          this.formData.other_income = data.other_income;

          setValue("other_relationship", data.other_relationship);
        });
      }

      // เพิ่มบรรทัดนี้เพื่อให้ description เดิมแสดงในช่องแก้ไข
      this.loanDescription = data.description || "";
    },

    getStaticData() {
      this.getDailyExpensesOptions();
      this.getLoanPurposesOptions();
      this.getEdu_lvl();
      this.getFaculty();
      this.getGraduatedLevel();
    },

    getFileUrl(filePath) {
      if (!filePath || typeof filePath !== "string") return "#"; // Check for invalid input

      // Prevent path traversal by allowing only specific prefixes
      if (!filePath.startsWith("/uploads/")) return "#";

      const baseUrl = `${process.env.VUE_APP_API_BASE_URL}` || `localhost:3000`;

      return `${baseUrl}${filePath}`;
    },

    showConsentIfNeeded() {
      const consentKey = "loanConsentDate";
      const lastConsent = localStorage.getItem(consentKey);

      const isMoreThan7Days = (dateString) => {
        const lastDate = new Date(dateString);
        const now = new Date();
        const diff = now - lastDate;
        const Days = 3 * 24 * 60 * 60 * 1000;
        return diff > Days;
      };

      if (!lastConsent || isMoreThan7Days(lastConsent)) {
        return Swal.fire({
          title: "ยืนยันการเปิดเผยข้อมูลส่วนบุคคล",
          icon: "warning",
          html: `
        <div style="text-align: left; font-size: 14px; line-height: 1.6;">
          <p>1. ข้าพเจ้ายินยอมให้กองทุนเงินให้กู้ยืมเพื่อการศึกษา ขอข้อมูลส่วนบุคคลของข้าพเจ้าจากหน่วยงานหรือองค์กร ทั้งภาครัฐ เอกชน หรือบุคคลใด ซึ่งเป็นผู้ครอบครองข้อมูลของข้าพเจ้า เพื่อการให้กู้ยืม การติดตามหนี้ และการดำเนินการใด ๆ ได้ตามวัตถุประสงค์ของกองทุนเงินให้กู้ยืมเพื่อการศึกษา</p>
          <p>2. ข้าพเจ้ายินยอมให้หน่วยงานหรือองค์กร ทั้งภาครัฐ เอกชน หรือบุคคลใด ซึ่งเป็นผู้ควบคุมหรือครอบครองข้อมูลของข้าพเจ้า เปิดเผย และ/หรือ แลกเปลี่ยนข้อมูลส่วนบุคคลของข้าพเจ้า ให้แก่กองทุนเงินให้กู้ยืมเพื่อการศึกษา เพื่อการให้กู้ยืม การติดตามหนี้ และการดำเนินการใด ๆ ได้ตามวัตถุประสงค์ของกองทุน</p>
          <p>3. ข้าพเจ้าจะไม่เพิกถอนการให้ความยินยอมตามหนังสือนี้ เว้นแต่จะได้รับความเห็นชอบจากกองทุนเงินให้กู้ยืมเพื่อการศึกษาเป็นลายลักษณ์อักษร</p>
          <p>4. ให้ถือว่าคู่ฉบับและบรรดาสำเนาภาพถ่าย ข้อมูลอิเล็กทรอนิกส์ หรือโทรสารที่ทำสำเนาขึ้นจากหนังสือให้ความยินยอมฉบับนี้ ไม่ว่าในรูปแบบใด ๆ เป็นหลักฐานในการให้ความยินยอมของข้าพเจ้าเช่นเดียวกัน</p>
          <p><strong>กรุณาอ่าน <a href="https://pdpa.mfu.ac.th/pdpa-6250.html" target="_blank">นโยบายความเป็นส่วนตัว</a> ก่อนดำเนินการต่อ</strong></p>
        </div>
      `,
          input: "checkbox",
          inputValue: 0,
          inputPlaceholder:
            "ข้าพเจ้าได้อ่านและเข้าใจข้อความในหนังสือให้ความยินยอมในการเปิดเผยข้อมูลฉบับนี้โดยตลอดแล้ว",
          confirmButtonText: "ยินยอมและดำเนินการต่อ",
          confirmButtonColor: "#3085d6",
          inputValidator: (result) => {
            return !result && "กรุณายืนยันความยินยอมก่อนดำเนินการต่อ";
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: true,
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem(consentKey, new Date().toISOString());
          }
        });
      } else {
        // ✅ return a resolved promise if no need to show popup
        return Promise.resolve();
      }
    },
    updateNeededHours() {
      if (
        this.user_studentType === "รายใหม่"
      ) {
        this.PublicServiceNumber_Needed = 1;
      } else {
        this.PublicServiceNumber_Needed = 36;
      }
    },
  },

  //Use function when the component is used
  async mounted() {
    const uldId = localStorage.getItem("uldId");
    if (uldId) {
      this.formID = uldId;
    }

    await this.getServerStatus();
    await this.getStaticData();

    // For edit form
    if (this.formID) {
      await this.getLoanData(uldId);
      await this.getServerStatus_editLoan();
    }

    const shouldAutofillMock =
      this.isMockMode &&
      sessionStorage.getItem("loanMockAutofill") === "true" &&
      !uldId;

    if (shouldAutofillMock) {
      sessionStorage.removeItem("loanMockAutofill");
      await this.$nextTick();
      this.fillMockDataUntilStep5();
    }
  },
  unmounted() {},
  beforeUnmount() {
    localStorage.removeItem("uldId");
  },
  watch: {
    user_studentType(newValue) {
      if (newValue !== "รายใหม่") {
        this.formData.has_welfare_card = "";
        this.formData.has_eef_scholarship = "";

        this.welfare_card_file = null;
        this.welfare_card_file_useOld = false;
        const welfareInput = document.getElementById("welfare_card_file");
        if (welfareInput) welfareInput.value = "";

        this.eef_scholarship_file = null;
        this.eef_scholarship_file_useOld = false;
        const eefInput = document.getElementById("eef_scholarship_file");
        if (eefInput) eefInput.value = "";
      }
    },
    selectedGuardian(newValue) {
      if (newValue === "ผู้ปกครองไม่ใช่บิดา มารดา") {
        this.showInput_other = true;
      } else {
        this.showInput_other = false;
      }
    },
    Marital_status_of_parents(newValue) {
      if (newValue == "ไม่ทราบ" || newValue == "สมรส") {
        this.show_marriage_pdf = false;
      } else {
        this.show_marriage_pdf = true;
      }
    },
    // 📝 เมื่อเปลี่ยนคำตอบบัตรสวัสดิการ ให้ clear ไฟล์
    "formData.has_welfare_card"(newValue) {
      if (newValue === "ไม่มี") {
        this.welfare_card_file = null;
        this.welfare_card_file_useOld = false;
        const fileInput = document.getElementById("welfare_card_file");
        if (fileInput) fileInput.value = "";
      }
    },
    // 📝 เมื่อเปลี่ยนคำตอบทุน กสศ. ให้ clear ไฟล์
    "formData.has_eef_scholarship"(newValue) {
      if (newValue === "ไม่เคย") {
        this.eef_scholarship_file = null;
        this.eef_scholarship_file_useOld = false;
        const fileInput = document.getElementById("eef_scholarship_file");
        if (fileInput) fileInput.value = "";
      }
    },
    studentID(newValue) {
      if (newValue == "") {
        Swal.fire({
          text: "เกิดข้อผิดพลาดในการดึงข้อมูลนักศึกษา",
          icon: "error",
          confirmButtonColor: "#964040",
        });
        return this.$router.push("/user");
      } else {
        this.getStaticData();
        if (!this.formID) {
          this.showConsentIfNeeded().then(() => {
            this.getStudentLoanLast();
            this.getServerStatus_kickUser();
          });
        }
      }
    },
  },
  computed: {
    totalPublicServiceNumber() {
      return (
        (parseInt(this.formData.Public_Service_Number_MFU333) || 0) +
        (parseInt(this.formData.Public_Service_Number_selfCreated) || 0) +
        (parseInt(this.formData.Public_Service_Number_eLearning) || 0)
      );
    },
    isPassed() {
      return this.totalPublicServiceNumber >= this.PublicServiceNumber_Needed;
    },
  },
};
</script>

<style scoped>
/* To Make Sure h1-h6 don't have extended space */
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}

.red-circle {
  position: absolute;
  width: 100%;
  height: 40%;
  background-color: #964040;
  z-index: -1;
}

.con-header {
  color: black;
}

.screen-control {
  height: 100vh;
  min-height: 100%;
  overflow-y: auto;
}

.progress-sticky-shell {
  position: sticky;
  top: 56px;
  z-index: 20;
  background-color: #fff;
}

.progress-sticky {
  padding-top: 0.5rem;
  padding-bottom: 0.25rem;
  background-color: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
}

.loan-page-shell {
  padding-left: 0;
  padding-right: 0;
}

.step5-text-wrap {
  white-space: normal;
  word-break: break-word;
}

.step5-wide-row {
  margin-right: 0;
}

.loan-summary-modern__hero {
  display: grid;
  gap: 1rem;
  padding: 1.25rem;
  border-radius: 22px;
  border: 1px solid #eadede;
  background: linear-gradient(135deg, #fffefe 0%, #f8f1f1 100%);
}

.loan-summary-modern__eyebrow {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #964040;
}

.loan-summary-modern__subtitle {
  color: #6c757d;
}

.loan-summary-modern__highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
}

.loan-summary-modern__highlight {
  display: grid;
  gap: 0.2rem;
  padding: 0.85rem 1rem;
  border-radius: 16px;
  background: rgba(150, 64, 64, 0.08);
  border: 1px solid rgba(150, 64, 64, 0.1);
}

.loan-summary-modern__highlight-label {
  font-size: 0.82rem;
  color: #7b5b5b;
}

.loan-summary-modern__highlight-value {
  color: #2c2c2c;
  font-size: 1rem;
}

.loan-summary-modern__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.loan-summary-card {
  height: 100%;
  padding: 1rem;
  border-radius: 20px;
  border: 1px solid #efe3e3;
  background: #ffffff;
}

.loan-summary-card--wide {
  grid-column: 1 / -1;
}

.loan-summary-card__title {
  font-size: 1rem;
  font-weight: 700;
  color: #964040;
  margin-bottom: 0.85rem;
}

.loan-summary-card__description {
  margin-bottom: 0.85rem;
  color: #6c757d;
}

.loan-summary-card__body {
  display: grid;
  gap: 0.75rem;
}

.loan-summary-field {
  display: grid;
  gap: 0.35rem;
  padding: 0.8rem 0.9rem;
  border-radius: 14px;
  background: #faf6f6;
  border: 1px solid #f0e5e5;
}

.loan-summary-field__label {
  font-size: 0.86rem;
  font-weight: 700;
  color: #6c757d;
}

.loan-summary-field__value,
.loan-summary-field__lines {
  color: #212529;
  font-weight: 600;
  white-space: pre-wrap;
  word-break: break-word;
}

.loan-summary-field__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.loan-summary-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.32rem 0.7rem;
  border-radius: 999px;
  background: #f4e4e4;
  color: #964040;
  font-size: 0.88rem;
  font-weight: 600;
}

.loan-summary-field__lines {
  display: grid;
  gap: 0.5rem;
}

#LoanForm {
  padding: 0.75vw 17vw 0vw 17vw;
}

/* For error input */
.error {
  border: 2px solid red;
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }

  100% {
    transform: translateX(0);
  }
}

/* Remove Arrow increase & decrease in input"number"*/
/* For Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* ------------------------------------------------ */
/* Progress Bar */
.progress-container {
  position: relative;
  top: auto;
  left: auto;
  transform: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  min-height: 120px;
  margin: 0 auto;
  padding: 5px 10vw;
  z-index: 2;
}

/* Step circles */
.progress-step {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100px;
  width: 0%;
}

/* Circles for each step */
.step-circle {
  width: 40px;
  height: 40px;
  min-height: 40px;
  background-color: #e0e0e0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
  z-index: 2;
}

.progress-line {
  position: relative;
  width: 100vw;
  height: 2px;
  margin-bottom: 60px;
  background-color: #e0e0e0;
  z-index: 1;
}

/* Highlight line and step circle when active */
.progress-step.active .step-circle {
  background-color: #a93a3a;
  /* Change to the active color */
}

.progress-step.active + .progress-line {
  background-color: #a93a3a;
}

/* Step labels */
.step-label {
  font-size: 14px;
  margin-top: 1vw;
  color: #555;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;

  text-shadow: -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white,
    1px 1px 0 white;
}

.step-label.active {
  color: black;
}

/* ------------------------------------------------ */
/* Phone, tablet */
@media (max-width: 768px) or (max-height: 768px) {
  /* Adjust the breakpoint as needed */
  #LoanForm {
    padding: 4vw 0vw 0vw 0vw;
  }

  .loan-summary-modern__grid {
    grid-template-columns: 1fr;
  }

  .progress-container {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100px;
    margin: 0 auto;
    padding: 5px 5vw;
    z-index: 2;
  }

  /* Circles for each step */
  .step-circle {
    width: 30px;
    height: 30px;
    min-height: 30px;
    background-color: #e0e0e0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 10px;
    z-index: 2;
  }

  /* Step labels */
.step-label {
  margin-top: 1vw;
  font-size: 10px;
  color: #555;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.loan-page-shell input.form-control[type="file"] {
  width: 100% !important;
  max-width: 100%;
  display: block;
}

/* progress line */
.progress-line {
    position: relative;
    width: 100vw;
    height: 2px;
    margin-bottom: 70px;
    background-color: #e0e0e0;
    z-index: 1;
  }
}

@media (max-width: 425px) or (max-height: 425px) {
  /* Adjust the breakpoint as needed */
  #LoanForm {
    padding: 5vw 0vw 0vw 0vw;
  }

  .progress-container {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100px;
    margin: 0 auto;
    padding: 5px 2vw;
    z-index: 2;
  }

  /* Circles for each step */
  .step-circle {
    width: 30px;
    height: 30px;
    min-height: 30px;
    background-color: #e0e0e0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 10px;
    z-index: 2;
  }

  /* Step labels */
  .step-label {
    margin-top: 1vw;
    font-size: 10px;
    color: #555;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /* progress line */
  .progress-line {
    position: relative;
    width: 100vw;
    height: 2px;
    margin-bottom: 70px;
    background-color: #e0e0e0;
    z-index: 1;
  }
}
</style>
